/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 64025:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(59970);module.exports = "../../app/cells/components/billing/billing_top_bar/show.erb";

/***/ }),

/***/ 61761:
/***/ ((module) => {

module.exports = "../../app/cells/components/billing/billing_top_bar_cell.rb";

/***/ }),

/***/ 65418:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(3020);module.exports = "../../app/cells/components/campaigns/interventions/modal_side_hero/show.erb";

/***/ }),

/***/ 42364:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/modal_side_hero_cell.rb";

/***/ }),

/***/ 70969:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/top_bar/show.erb";

/***/ }),

/***/ 81848:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/top_bar_cell.rb";

/***/ }),

/***/ 10457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(43994);module.exports = "../../app/cells/components/campaigns/widgets/live_tag/show.erb";

/***/ }),

/***/ 71341:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/widgets/live_tag_cell.rb";

/***/ }),

/***/ 68608:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(84778);module.exports = "../../app/cells/components/campaigns/widgets/offer_label/show.erb";

/***/ }),

/***/ 66483:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/widgets/offer_label_cell.rb";

/***/ }),

/***/ 55875:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(22327);module.exports = "../../app/cells/components/cookies_agreement/show.erb";

/***/ }),

/***/ 22797:
/***/ ((module) => {

module.exports = "../../app/cells/components/cookies_agreement_cell.rb";

/***/ }),

/***/ 26300:
/***/ ((module) => {

module.exports = "../../app/cells/components/dev_loading/show.erb";

/***/ }),

/***/ 93955:
/***/ ((module) => {

module.exports = "../../app/cells/components/dev_loading_cell.rb";

/***/ }),

/***/ 45327:
/***/ ((module) => {

module.exports = "../../app/cells/components/google_one_tap_auth/show.erb";

/***/ }),

/***/ 33250:
/***/ ((module) => {

module.exports = "../../app/cells/components/google_one_tap_auth_cell.rb";

/***/ }),

/***/ 88683:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(39896);module.exports = "../../app/cells/components/intervention_bottom_bar/show.erb";

/***/ }),

/***/ 80925:
/***/ ((module) => {

module.exports = "../../app/cells/components/intervention_bottom_bar_cell.rb";

/***/ }),

/***/ 81241:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(73920);
__webpack_require__(53584);
__webpack_require__(51000);
__webpack_require__(1211);module.exports = "../../app/cells/components/menu/show.erb";

/***/ }),

/***/ 79383:
/***/ ((module) => {

module.exports = "../../app/cells/components/menu_cell.rb";

/***/ }),

/***/ 53584:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30125);module.exports = "../../app/cells/components/menu/submenu/contest.erb";

/***/ }),

/***/ 1211:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30125);module.exports = "../../app/cells/components/menu/submenu/courses.erb";

/***/ }),

/***/ 51000:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30125);module.exports = "../../app/cells/components/menu/submenu/lessons.erb";

/***/ }),

/***/ 44481:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/account_limit_free_modal/campaign_modal.erb";

/***/ }),

/***/ 27353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(31654);
__webpack_require__(59406);module.exports = "../../app/cells/components/modals/account_limit_free_modal/show.erb";

/***/ }),

/***/ 11769:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/account_limit_free_modal_cell.rb";

/***/ }),

/***/ 25624:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(31654);module.exports = "../../app/cells/components/modals/account_limit_free_modal/modal_content.erb";

/***/ }),

/***/ 64746:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/login_register_modal/account_create_modal.erb";

/***/ }),

/***/ 96794:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/login_register_modal/show.erb";

/***/ }),

/***/ 88473:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/login_register_modal/login_modal.erb";

/***/ }),

/***/ 71261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(10083);module.exports = "../../app/cells/components/modals/not_subscribed_user_modal/show.erb";

/***/ }),

/***/ 9570:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/not_subscribed_user_modal_cell.rb";

/***/ }),

/***/ 29404:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/pay_wall_modal/components/cta.erb";

/***/ }),

/***/ 61094:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(17136);module.exports = "../../app/cells/components/modals/pay_wall_modal/show.erb";

/***/ }),

/***/ 81742:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/pay_wall_modal_cell.rb";

/***/ }),

/***/ 4571:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(99669);module.exports = "../../app/cells/components/modals/setup/area.erb";

/***/ }),

/***/ 18603:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(99669);
__webpack_require__(66857);module.exports = "../../app/cells/components/modals/setup/show.erb";

/***/ }),

/***/ 63053:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/setup_cell.rb";

/***/ }),

/***/ 2231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(99669);module.exports = "../../app/cells/components/modals/setup/redirect.erb";

/***/ }),

/***/ 53473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(58355);module.exports = "../../app/cells/components/new_menu/show.erb";

/***/ }),

/***/ 98222:
/***/ ((module) => {

module.exports = "../../app/cells/components/new_menu_cell.rb";

/***/ }),

/***/ 24570:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(33233);module.exports = "../../app/cells/components/payment_error_topbar/show.erb";

/***/ }),

/***/ 96320:
/***/ ((module) => {

module.exports = "../../app/cells/components/payment_error_topbar_cell.rb";

/***/ }),

/***/ 81732:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(52456);module.exports = "../../app/cells/components/subscription_expiration_modal/show.erb";

/***/ }),

/***/ 72500:
/***/ ((module) => {

module.exports = "../../app/cells/components/subscription_expiration_modal_cell.rb";

/***/ }),

/***/ 4611:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(98331);module.exports = "../../app/cells/components/trial/top_bar/activated/show.erb";

/***/ }),

/***/ 14308:
/***/ ((module) => {

module.exports = "../../app/cells/components/trial/top_bar/activated_cell.rb";

/***/ }),

/***/ 70792:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(87847);module.exports = "../../app/cells/components/trial/top_bar/expired/show.erb";

/***/ }),

/***/ 9886:
/***/ ((module) => {

module.exports = "../../app/cells/components/trial/top_bar/expired_cell.rb";

/***/ }),

/***/ 49251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(52586);module.exports = "../../app/cells/components/trial/top_bar/show.erb";

/***/ }),

/***/ 27320:
/***/ ((module) => {

module.exports = "../../app/cells/components/trial/top_bar_cell.rb";

/***/ }),

/***/ 59970:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"ajzoaTSlkwUhW6B5QmsZ","exclamation":"XMiduDuGBV6nBNXiJ5qE","title":"PhUHOSFZBiu0pmsAwi0w","text":"Jq6uJIBsFiyNoLu1twtE","content":"F5NWa7fDtCPntkoSBsIk","ctas":"aGc2psmPBdICdzPl_4fC","pending":"DKIVXZv95B1M9Owjy1zP","paid":"wRtwySy5WLBMDdpN9A87"});

/***/ }),

/***/ 93084:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 3020:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"J3cJ3PzlLrvfkaBMlamy"});

/***/ }),

/***/ 43994:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"DR8xpQlQk73_AUWSSHRd","wrap":"Qmt2IENUjWkUB9guLc4L","live":"RMwep87CvRdOX2C1yqRA","signal":"BiN0S_lrpqVcGsJ2vzwZ","online":"Mohh66mmK9Tup7M2g81w","pulse":"jCicmi0Lj8z_VlHlVMrI"});

/***/ }),

/***/ 84778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"worker-campaign-current-discount-tag":"EKETlBLp7ptn_3x7UoSK","workerCampaignCurrentDiscountTag":"EKETlBLp7ptn_3x7UoSK","worker-campaign-current-discount-tag-content":"WYtuVOm_nqHBNKIYZRAQ","workerCampaignCurrentDiscountTagContent":"WYtuVOm_nqHBNKIYZRAQ"});

/***/ }),

/***/ 22327:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"SM6sWrR7Ha85UIv25Vxd","content":"ahdUXTdC4TXNB6WjEs5T","text":"MDkG5i_IP9MiUkQvq4qH","info-link":"BMUHSx0HSVl0H1Tya4eI","infoLink":"BMUHSx0HSVl0H1Tya4eI","cta":"IzjlkP5cLQY8Feb0Hx9U"});

/***/ }),

/***/ 56857:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 56278:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 3161:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 26768:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 49016:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 39896:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"bottom-bar-closed-info":"EgpdweUlt1Z5hjAU0eGl","bottomBarClosedInfo":"EgpdweUlt1Z5hjAU0eGl","icon-wrapper":"aRRMs7T5OOFPDiBypnUC","iconWrapper":"aRRMs7T5OOFPDiBypnUC","icon":"ICqVI6DMxTZnoQoZ0k4e","title-wrapper":"iFotLVDE_IBlsmiIZHcH","titleWrapper":"iFotLVDE_IBlsmiIZHcH","collapsable-button":"To5Wg2a38aFaY8VyDlEG","collapsableButton":"To5Wg2a38aFaY8VyDlEG","bottom-bar-content":"ZGxl9m11qxqO3SVucBXj","bottomBarContent":"ZGxl9m11qxqO3SVucBXj","title-content":"YyQnhRE43T4LsAsvLdl7","titleContent":"YyQnhRE43T4LsAsvLdl7","bullets-content":"JnSUjkke8ViHfFoYVegA","bulletsContent":"JnSUjkke8ViHfFoYVegA","cta":"rZs10s83j747eoISddmL","bullets":"FEaKqrQ5HcXGo110OtN9","icon-holder":"o9ds4F0cGZiaR2uLv8eg","iconHolder":"o9ds4F0cGZiaR2uLv8eg","ballot":"WEoeaNaj9mxOWuMMxout","list-alt":"vTZJM6r8siqLiJ4qhfQ5","listAlt":"vTZJM6r8siqLiJ4qhfQ5","player":"vwLHIF0D2S0xzD104Ue5","pdf":"VH4HewR5BaieUYVLDwwW","chart":"BangR69n2SPimUy2IW5y","user":"_xBRCczP2prklbo305Rj","landmark":"NcxFfCohNBhvtWHTXFl7","basic":"NG779axgfj7tGmO91lgV","more":"TqBZD2Yaj59OphHCdvE5"});

/***/ }),

/***/ 99226:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 73920:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"main-menu":"L1UdXgTve2LkE6j6Gpxu","mainMenu":"L1UdXgTve2LkE6j6Gpxu","container":"U7VWlD2AccOoEgzhjK6K","menu-segment":"T5e5SQ222gxtf4YhmEjy","menuSegment":"T5e5SQ222gxtf4YhmEjy","menu-nav":"bhzlsf_pEmJ5GHpTGLMX","menuNav":"bhzlsf_pEmJ5GHpTGLMX","current":"uHfNI8JRBPgD1bRahJQV","dropdown-mega":"KTiriaczRyhJmjhb4jLy","dropdownMega":"KTiriaczRyhJmjhb4jLy","dropdown":"kpSKA_BlOOthBZC158CL","caret":"H8H5hnu2sXBepWu_YOpb","icon":"tDAb2dw2Gc3Zy5KFQJne","elipse-menu":"r_qD75EsTCbVi9U8pgxw","elipseMenu":"r_qD75EsTCbVi9U8pgxw","dropdown-menu":"CSg_Q3f4uynoituBrkGp","dropdownMenu":"CSg_Q3f4uynoituBrkGp","badge":"P8lAvKYT3zTaGbGIr2n8","dropdown-menu-mega":"DXBSueq8_6vtal0Vak2C","dropdownMenuMega":"DXBSueq8_6vtal0Vak2C","tag-beta":"B39Sa4I11zjBvEgekGHu","tagBeta":"B39Sa4I11zjBvEgekGHu","tag-beta--new":"Fy7q_W9trCfSJhRex0TQ","tagBetaNew":"Fy7q_W9trCfSJhRex0TQ","segment-enem":"qFQb1Bt9p8EKR1zjDw_v","segmentEnem":"qFQb1Bt9p8EKR1zjDw_v","segment-militares":"q1G4Qjn3TOEKrBOG8UZ9","segmentMilitares":"q1G4Qjn3TOEKrBOG8UZ9","segment-oab":"GPqc6PWMQAYjjdb63_bc","segmentOab":"GPqc6PWMQAYjjdb63_bc","segment-vestibular":"VnjtutwzoU5HSKmr5T0N","segmentVestibular":"VnjtutwzoU5HSKmr5T0N","segment-concursos":"gD5vjRecviVLNelhvVSf","segmentConcursos":"gD5vjRecviVLNelhvVSf"});

/***/ }),

/***/ 30125:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"container":"AOEoPLAwwusTxme_2p97","content-set":"qysFec7hchFiZQ7d21MD","contentSet":"qysFec7hchFiZQ7d21MD","lessons":"lmEdfAf0s3f67L5vXh2M","courses":"PcbcrqLiOSTshg80d4ZK","news":"f5sLiHGZeGbkh8znEXig","content-start":"h_CWkbcQ_nTgC30dtIMW","contentStart":"h_CWkbcQ_nTgC30dtIMW","content":"IX3C2T3aCrYJfq8tAnVh","states":"f3pVTRnUK7iH80SopHPm","title":"xI0RSN1QFk7pqmBRkjgX","link-group":"TiEX_yjI3zr89bYuuhzI","linkGroup":"TiEX_yjI3zr89bYuuhzI","states-links":"qAtgWpHlv5VVLTdNlUHJ","statesLinks":"qAtgWpHlv5VVLTdNlUHJ","link-group-primary":"IPc1OX91bgtC6D21ms7O","linkGroupPrimary":"IPc1OX91bgtC6D21ms7O"});

/***/ }),

/***/ 31654:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"modal-body-content":"EalehsoHU2rmyoOBUTcZ","modalBodyContent":"EalehsoHU2rmyoOBUTcZ","modal-dialog":"MUwbutEeEwi8wOxVxpKi","modalDialog":"MUwbutEeEwi8wOxVxpKi","title":"TQsjBPckncdr9_HyGNnv","text":"KW643JCXWJxm6iQfTSgX","options-title":"Hp5MhMtTWybNNoxK3T3g","optionsTitle":"Hp5MhMtTWybNNoxK3T3g","content":"G_35P1M3uUk0YMhKKLkG","benefits":"hV80DUNP4bhW5_OlXwNo","illustration":"ewUijsmkhbidBWhLl5NY","actions":"Woubf058n_YgN3krAeMs","btn-link":"hCDJMdFGHf7UhpfIgbwo","btnLink":"hCDJMdFGHf7UhpfIgbwo","cta-button":"zPsG3KbZAembdzyj42IX","ctaButton":"zPsG3KbZAembdzyj42IX","mobile-actions":"aP8C80tu1doXb4t_N_Ie","mobileActions":"aP8C80tu1doXb4t_N_Ie"});

/***/ }),

/***/ 17335:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 83581:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 57312:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 10083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"alignment":"OTsQskqDUU7pnqsbWpOz","modal":"njRXvCxCzPExuR6gkq8C","image":"CVT5vjqNrObY8OC47A6D","content":"nDqQ0bL4D6irs5E9uhSY","text":"rxPYrxavplytVU5kQvwd","title":"wu0m4SmHfbmNbvGsYP2L","subtitle":"LrXuNmN53p_rxYJqp3Yc","footer":"UtXFh0CfG9a_o5ODdqUP"});

/***/ }),

/***/ 17136:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"dialog":"StMt6ZH04Dlf3TaCNDpw","body":"I41Ezaj53CK3dudzT3ND","content":"q4p8SmonnDDhXEOHel7Q","paywall-container":"B3KYE73OrcQtbeNwcxOK","paywallContainer":"B3KYE73OrcQtbeNwcxOK","paywall-plan":"rU8xpkbQGjE7W2vTaXcR","paywallPlan":"rU8xpkbQGjE7W2vTaXcR","paywall-data":"qCYS7bdHSTjdm1VMOaWQ","paywallData":"qCYS7bdHSTjdm1VMOaWQ","paywall-data-empty":"occLCd_kNpao1xHU_Q02","paywallDataEmpty":"occLCd_kNpao1xHU_Q02","paywall-cta":"mnFZ4N9P3xy72_nA7GDg","paywallCta":"mnFZ4N9P3xy72_nA7GDg"});

/***/ }),

/***/ 4381:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 39285:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 99669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"BcnxGd7LV2oc57iEb3sd","title":"gpjOnWhaVXntgrSjVIPQ","subtitle":"KSgKTDfG_mc3UuWD65QJ","products":"xbpQgvSJ15SC8DeSXpyH","product":"h0OQSVx0mmi2OFfwYjSC","icon":"gtr89aZP2M6Im3Zxv9_k","options":"_3SaXI7eoAIWACkdY6pl","option":"NvkAgGc0CdY2FUxXiPZl","option-icon":"x8EWE4W_wcAcggRN299m","optionIcon":"x8EWE4W_wcAcggRN299m","option-content":"uBuaLycy8Cl43DyNhqQQ","optionContent":"uBuaLycy8Cl43DyNhqQQ","option-title":"rSOPNV4BcZeKt6MA2YDl","optionTitle":"rSOPNV4BcZeKt6MA2YDl","option-subtitle":"e1zRnFgrPyk6CDaKCING","optionSubtitle":"e1zRnFgrPyk6CDaKCING","divider":"PcmTkv5TFG3oRSgD2FXR","loading":"CI7ztWSpZYRvhwATyntY","ellipsis":"icc_nGGd6rmEYgMqTFB7","ellipsis1":"ucgFRUFLyXjYY4oJprV6","ellipsis2":"fk8YOgSyP_5mnh3M8e9Q","ellipsis3":"O_hbhl1nERCI2AeJBx10"});

/***/ }),

/***/ 58355:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"AYryaQLXtXpszYLqyXhW","segment":"g_n0cy1ezBOwjXRbsOH6","segment-menu":"lNHxOdi7T4fx5vr5i_cM","segmentMenu":"lNHxOdi7T4fx5vr5i_cM","segment-menu-container":"af59a3w7GK0KC_owbv9d","segmentMenuContainer":"af59a3w7GK0KC_owbv9d","segment-tab":"X5LPSWj3VAkUCAea6_3r","segmentTab":"X5LPSWj3VAkUCAea6_3r","banners":"HxNWtkpwyMuZaS_fpuyq"});

/***/ }),

/***/ 33233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"payment-error-topbar":"WHHN3Na4zLN5KTUTB2CQ","paymentErrorTopbar":"WHHN3Na4zLN5KTUTB2CQ","text-mobile":"nBx18bNgWnbkMPRWZxfu","textMobile":"nBx18bNgWnbkMPRWZxfu","text-desktop":"BQhwrqXSi2QTOEoOdGXz","textDesktop":"BQhwrqXSi2QTOEoOdGXz","icon":"fH_ssKUpJjNioeGarqGE"});

/***/ }),

/***/ 83207:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 52456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"lhpK1J0CQcKmJ5SqjUIM","content":"DOpS4TfJw_nSJQI0u6SB","header":"V5PnKTWWGaTIbsoF6iqq","days":"xS1O7CvdkwMgr2l4Yd_K","buttons":"HlGBW45q6ikE7qjyABEd","text":"nJsBMDOKuc5iSCwN7t3W","description":"AO09U6XrbikLL58yEud6"});

/***/ }),

/***/ 98331:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"title":"A9C9tlttirxa16juxHHX","cta":"cVlmZu02XT1SkAIiI4cO"});

/***/ }),

/***/ 87847:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"title":"dP3G9htmq7BDf95m0m1L","cta":"McXAYLe_SDSnoQbZwExZ"});

/***/ }),

/***/ 52586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"q-top-bar-trial":"qmfaMdfzQ51W8vuIZs9o","qTopBarTrial":"qmfaMdfzQ51W8vuIZs9o","q-top-bar-trial-message":"cKEr6BIGMzC7ne_nOvNQ","qTopBarTrialMessage":"cKEr6BIGMzC7ne_nOvNQ","q-top-bar-trial-icon":"va7Wf3MXXuOaH_8JWDps","qTopBarTrialIcon":"va7Wf3MXXuOaH_8JWDps","q-top-bar-trial-close":"Rx6FoeMiwUTUtpErH7ey","qTopBarTrialClose":"Rx6FoeMiwUTUtpErH7ey"});

/***/ }),

/***/ 53080:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 89952:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 83654:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 44944:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 8149:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 43456:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

;// CONCATENATED MODULE: ./components/ajax_sidebar/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/ajax_component_loader/index.js
var ajax_component_loader = __webpack_require__(62346);
// EXTERNAL MODULE: ./utils/event_manager/index.js
var event_manager = __webpack_require__(69705);
;// CONCATENATED MODULE: ./components/ajax_sidebar/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



class AjaxSidebar {
    renderTitle() {
        this.$title.empty();
        if (this.state.context.icon) {
            this.$title.append(`<i class="q-icon q-icon-${this.state.context.icon}" />`);
        }
        this.$title.append(`<span>${this.state.context.title}</span>`);
        this.$title.attr('aria-label', this.state.context.title);
    }
    renderComponent() {
        var _this = this;
        return _async_to_generator(function*() {
            _this.$contentTarget.empty().append('<div class="q-spinner-container"><i class="q-spinner"/></div>');
            const { componentName: component, type, componentAsset, data } = _this.state.context;
            try {
                yield ajax_component_loader/* default.load */.Z.load({
                    component,
                    type,
                    data,
                    target: _this.$contentTargetSelector,
                    asset_key: `components/${componentAsset}`
                });
                _this.$contentTarget.removeClass('error').addClass('loaded');
                event_manager/* EventManager.publish */.Q.publish('ajaxSidebar.open');
            } catch (res) {
                _this.close();
                _this.$contentTarget.removeClass('loaded').addClass('error');
            }
        })();
    }
    close() {
        this.$toggleInput.prop('checked', false);
    }
    handleVisibilityChange() {
        this.state.isVisible = this.$toggleInput.is(':checked');
        if (this.state.isVisible) {
            return;
        }
        event_manager/* EventManager.publish */.Q.publish('ajaxSidebar.closed');
        this.$contentTarget.html('');
    }
    handleTrigger(event) {
        event.preventDefault();
        const data = _extends({}, event.currentTarget.dataset);
        if (data.limitReached === 'true' || data.limitReached === true) {
            return;
        }
        if (this.state.isVisible) {
            return;
        }
        this.$toggleInput.prop('checked', true);
        const { title, icon, componentName, componentAsset } = data;
        this.state.context = {
            title,
            icon,
            componentName,
            componentAsset,
            data,
            type: componentAsset || 'component'
        };
        this.renderTitle();
        this.renderComponent();
    }
    _bindToggleInput() {
        this.$toggleInput.on('change', this.handleVisibilityChange.bind(this));
    }
    _bindButtonClose() {
        this.$btnClose.on('click', ()=>this.close());
    }
    _bindTriggers() {
        window.jQuery(document).off('click.triggerAjaxSidebar').on('click.triggerAjaxSidebar', this.triggerSelector, this.handleTrigger.bind(this));
    }
    bindAll() {
        this._bindToggleInput();
        this._bindButtonClose();
        this._bindTriggers();
    }
    constructor(el){
        this.triggerSelector = '[data-ajax-sidebar]';
        this.$sidebar = window.jQuery(el);
        this.$toggleInput = window.jQuery('#ajax-sidebar-toggle-input');
        this.$btnClose = window.jQuery('#js-ajax-sidebar .q-close');
        this.$contentTargetSelector = '.js-sidebar-content';
        this.$contentTarget = window.jQuery(this.$contentTargetSelector, this.$sidebar);
        this.$title = window.jQuery('.js-sidebar-title', this.$sidebar);
        this.state = {
            isVisible: false,
            context: {}
        };
        this.bindAll();
    }
}
const start = ()=>{
    const sidebar = document.getElementById('js-ajax-sidebar');
    if (sidebar && !sidebar.ajaxSidebarInstance) {
        sidebar.ajaxSidebarInstance = new AjaxSidebar(sidebar);
    }
};
window.jQuery(document).on('turbolinks:load', ()=>start());
start();


/***/ }),

/***/ 41705:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64025);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61761);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);


window.jQuery(document).on('turbolinks:load', ()=>{
    window.jQuery('#js-paid-button').on('click', ()=>{
        Thor.UserPreference.update(null, {
            data: {
                user_preferences: {
                    confirmed_payment_id: gon.ticket_payment_id
                }
            }
        }).then(()=>{
            Turbolinks.visit(window.location.toString());
        }).catch(()=>{
            toastr.error('Não foi possível processar sua confirmação. Por favor, tente novamente.');
        });
    });
});


/***/ }),

/***/ 87665:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93084);



/***/ }),

/***/ 56377:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65418);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42364);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),

/***/ 94471:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

;// CONCATENATED MODULE: ./components/campaigns/interventions/top_bar/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./components/campaigns/interventions/top_bar/index.erb
var top_bar = __webpack_require__(70969);
// EXTERNAL MODULE: ./components/campaigns/interventions/top_bar/index.rb
var interventions_top_bar = __webpack_require__(81848);
// EXTERNAL MODULE: ./components/campaigns/widgets/live_tag/index.erb
var live_tag = __webpack_require__(10457);
// EXTERNAL MODULE: ./components/campaigns/widgets/live_tag/index.rb
var widgets_live_tag = __webpack_require__(71341);
;// CONCATENATED MODULE: ./components/campaigns/widgets/live_tag/index.js



// EXTERNAL MODULE: ./components/campaigns/widgets/offer_label/index.erb
var offer_label = __webpack_require__(68608);
// EXTERNAL MODULE: ./components/campaigns/widgets/offer_label/index.rb
var widgets_offer_label = __webpack_require__(66483);
// EXTERNAL MODULE: ./components/campaigns/widgets/offer_label/index.module.scss
var index_module = __webpack_require__(84778);
;// CONCATENATED MODULE: ./components/campaigns/widgets/offer_label/index.js




;// CONCATENATED MODULE: ./components/campaigns/interventions/top_bar/index.js







/***/ }),

/***/ 8150:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./components/cookies_agreement/index.erb
var cookies_agreement = __webpack_require__(55875);
// EXTERNAL MODULE: ./components/cookies_agreement/index.rb
var components_cookies_agreement = __webpack_require__(22797);
// EXTERNAL MODULE: ./utils/cookie_manager/index.js
var cookie_manager = __webpack_require__(88526);
;// CONCATENATED MODULE: ./utils/consent_manager/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

const COOKIE_NAME = '_my_consent_token';
const URLS = {
    development: 'https://ktocqilc49.execute-api.us-east-1.amazonaws.com/staging/consent',
    staging: 'https://ktocqilc49.execute-api.us-east-1.amazonaws.com/staging/consent',
    production: 'https://mmmos95aq3.execute-api.us-east-1.amazonaws.com/production/consent'
};
class ConsentManager {
    static accept(user) {
        var _this = this;
        return _async_to_generator(function*() {
            const token = yield _this.generateToken(user);
            if (token) {
                _this.setToken(token);
            }
        })();
    }
    static isAccepted() {
        const token = this.getToken();
        return !!token;
    }
    static generateToken(user) {
        return _async_to_generator(function*() {
            const userId = user ? user.id : null;
            let token = null;
            try {
                const response = yield window.jQuery.ajax({
                    url: URLS[RAILS_ENV],
                    method: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        user_id: userId
                    })
                });
                return JSON.parse(response).token;
            } catch (e) {
                return null;
            }
        })();
    }
    static setToken(token) {
        cookie_manager/* default.setPersistentCookie */.Z.setPersistentCookie(COOKIE_NAME, token);
    }
    static getToken() {
        return cookie_manager/* default.getCookie */.Z.getCookie(COOKIE_NAME);
    }
}


;// CONCATENATED MODULE: ./components/cookies_agreement/index.js
function cookies_agreement_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function cookies_agreement_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                cookies_agreement_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                cookies_agreement_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



class CookiesAgreement {
    accept() {
        var _this = this;
        return cookies_agreement_async_to_generator(function*() {
            ConsentManager.accept(window.currentUser);
            _this.cookiesBar.hide();
        })();
    }
    process() {
        if (ConsentManager.isAccepted()) {
            this.cookiesBar.hide();
        } else {
            this.cookiesBar.show();
        }
    }
    bind() {
        this.acceptButton.on('click', (e)=>this.accept());
    }
    constructor(){
        this.cookiesBar = window.jQuery('.js-cookies-agreement');
        this.acceptButton = window.jQuery('.js-allow-cookies');
        this.status = this.cookiesBar.data('status');
        if (this.status === 'enabled') {
            this.bind();
            this.process();
        }
    }
}
(()=>{
    document.addEventListener("turbolinks:load", ()=>{
        new CookiesAgreement();
    });
})();


/***/ }),

/***/ 18312:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26300);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93955);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),

/***/ 95890:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45327);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33250);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),

/***/ 40370:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./components/intervention_bottom_bar/index.erb
var intervention_bottom_bar = __webpack_require__(88683);
// EXTERNAL MODULE: ./components/intervention_bottom_bar/index.rb
var components_intervention_bottom_bar = __webpack_require__(80925);
;// CONCATENATED MODULE: ./components/intervention_bottom_bar/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/intervention_bottom_bar/index.js



(function($) {
    document.addEventListener('turbolinks:load', function() {
        $('#intervention-collapse-button').on('click', function() {
            const interventionBottomBar = $('#qc-intervention-bottom-bar');
            const collapseData = $(this).data('collapse');
            $(this).data('collapse', !collapseData);
            if (interventionBottomBar.hasClass('collapsed')) {
                interventionBottomBar.removeClass('collapsed');
                $(this).find('span').text('Mostrar mais');
            } else {
                interventionBottomBar.addClass('collapsed');
                $(this).find('span').text('Mostrar menos');
            }
        });
    });
})(window.jQuery);


/***/ }),

/***/ 67566:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/lesson_freemium/alert/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/lesson_freemium/alert/index.js



/***/ }),

/***/ 35441:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/lesson_freemium/banner/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/lesson_freemium/banner/index.js



/***/ }),

/***/ 39380:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/lesson_freemium/sign_in/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/lesson_freemium/sign_in/index.js



/***/ }),

/***/ 99406:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99226);



/***/ }),

/***/ 89506:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81241);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79383);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);


window.jQuery(document).on('turbolinks:load', function() {
    const initDropdown = ()=>{
        window.jQuery('.dropdown').on('click', function() {
            const $dropdown = window.jQuery(this).closest('.dropdown');
            const $dropdownMenu = $dropdown.find('.dropdown-menu');
            window.jQuery('.dropdown').not($dropdown).removeClass('active');
            window.jQuery('.dropdown-menu').not($dropdownMenu).hide();
            window.jQuery('.segment-button').removeClass('active');
            window.jQuery('#segmentNewMenu').hide();
            $dropdown.toggleClass('active');
            $dropdownMenu.toggle();
        });
        window.jQuery(document).on('click', function(e) {
            if (!window.jQuery(e.target).closest('.dropdown').length) {
                window.jQuery('.dropdown').removeClass('active');
                window.jQuery('.dropdown-menu').hide();
            }
        });
    };
    initDropdown();
});


/***/ }),

/***/ 31900:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/menu_old/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/menu_old/index.js



/***/ }),

/***/ 49676:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _campaign_modal_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44481);
/* harmony import */ var _campaign_modal_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_campaign_modal_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27353);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11769);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modal_content_erb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25624);
/* harmony import */ var _modal_content_erb__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modal_content_erb__WEBPACK_IMPORTED_MODULE_3__);






/***/ }),

/***/ 24363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ AccountLimitFreeModal)
/* harmony export */ });
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17335);
/* harmony import */ var utils_countdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56392);


class AccountLimitFreeModal {
    countdownV1Animation() {
        const fullTime = 10;
        const $circle = window.jQuery('#out-circle');
        const $counterText = window.jQuery('#counter-text');
        $counterText.text(fullTime);
        let remainingTime = fullTime;
        const circumference = 2 * Math.PI * $circle.attr('r');
        $circle.css({
            'stroke-dasharray': circumference,
            'stroke-dashoffset': 0,
            transform: 'rotate(-90deg)',
            'transform-origin': '50% 50%'
        });
        setTimeout(()=>{
            const interval = setInterval(function() {
                remainingTime--;
                $counterText.text(remainingTime);
                const dashoffset = circumference * ((fullTime - remainingTime) / fullTime) * 1.5;
                $circle.css('stroke-dashoffset', dashoffset);
                const adjustedDashoffset = Math.min(dashoffset, circumference);
                $circle.css('stroke-dashoffset', adjustedDashoffset);
                if (remainingTime <= 0) {
                    clearInterval(interval);
                }
            }, 80);
        }, 1000);
    }
    countdownV2Animation() {
        const fullTime = 24 * 60 * 60;
        const now = new Date();
        const secondsSinceMidnight = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
        const remainingTime = fullTime - secondsSinceMidnight;
        const $circle = window.jQuery('#out-circle');
        const circumference = 2 * Math.PI * $circle.attr('r');
        const initialOffset = circumference * (secondsSinceMidnight / fullTime);
        $circle.css({
            'stroke-dasharray': circumference,
            'stroke-dashoffset': initialOffset,
            transform: 'rotate(-90deg)',
            'transform-origin': '50% 50%'
        });
        setTimeout(()=>{
            let currentRemainingTime = remainingTime;
            const interval = setInterval(function() {
                currentRemainingTime--;
                const dashoffset = circumference * ((fullTime - currentRemainingTime) / fullTime);
                $circle.css('stroke-dashoffset', dashoffset);
                if (currentRemainingTime <= 0) {
                    clearInterval(interval);
                }
            }, 1000);
        });
    }
    showTimeLeft() {
        (0,utils_countdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            selector: '.js-account-limit-questions-modal .limit-countdown',
            template: '%H:%M:%S'
        });
        (0,utils_countdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            selector: '.js-account-limit-questions-modal .subtitle-limit-countdown',
            template: '%H:%M:%S'
        });
    }
    selectVersion() {
        var _gon_flags;
        const modalLimitation = (_gon_flags = gon.flags) == null ? void 0 : _gon_flags.modal_limitation;
        if (modalLimitation) {
            if (modalLimitation.showV2) {
                this.countdownV2Animation();
            } else {
                this.countdownV1Animation();
            }
        }
    }
    load() {
        this.showTimeLeft();
        this.selectVersion();
    }
}



/***/ }),

/***/ 70637:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83581);

(function($) {
    'use strict';
    const sendEmail = ($button)=>{
        Thor.User.send_email_confirmation({
            user_id: currentUser.id
        }, {}).then(()=>{
            $button.parent().html($button.data('already-sent'));
        });
    };
    $(document).on('click', '.js-btn-resend-email', (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const $button = $(event.currentTarget);
        sendEmail($button);
    });
})(window.jQuery);


/***/ }),

/***/ 24955:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/modals/lifelong_upgrade_modal/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/modals/lifelong_upgrade_modal/index.js

(()=>{
    document.addEventListener('turbolinks:load', function() {
        const $modal = window.jQuery('.lifelong-upgrade-modal');
        const localStorageSlot = `lifelongUpgradePortal.${currentUser.id}`;
        function openModal() {
            $modal.addClass('lifelong-upgrade-modal--open');
            window.jQuery('body').addClass('modal-open');
            UserTracker.emit('event', {
                eventName: 'lifelong modal appeared'
            });
        }
        function attachEvents() {
            const $closeButton = $modal.find('header button');
            const $upgradeButtons = $modal.find('a');
            $closeButton.on('click', ()=>{
                $modal.removeClass('lifelong-upgrade-modal--open');
                window.jQuery('body').removeClass('modal-open');
                localStorage.setItem(localStorageSlot, true);
            });
            $upgradeButtons.on('click', (event)=>{
                event.preventDefault();
                UserTracker.emit('event', {
                    eventName: 'lifelong modal accepted'
                });
                localStorage.setItem(localStorageSlot, true);
                window.location.href = event.currentTarget.getAttribute('href');
            });
        }
        function userHasAlreadyViewed() {
            if (localStorage.getItem(localStorageSlot) === null) {
                localStorage.setItem(localStorageSlot, false);
            }
            return localStorage.getItem(localStorageSlot) === 'true';
        }
        function init() {
            if ($modal.length === 0 || userHasAlreadyViewed()) {
                return;
            }
            attachEvents();
            openModal();
        }
        init();
    });
})();


/***/ }),

/***/ 66301:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _components_campaigns_interventions_modal_side_hero__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56377);
/* harmony import */ var _images_login_register_modal_halfpage_modal_360_jpg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10089);
/* harmony import */ var _images_login_register_modal_halfpage_modal_400_jpg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87758);
/* harmony import */ var _account_create_modal_erb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64746);
/* harmony import */ var _account_create_modal_erb__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_account_create_modal_erb__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _images_questions_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35496);
/* harmony import */ var _images_statistics_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49304);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96794);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57312);
/* harmony import */ var _login_modal_erb__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88473);
/* harmony import */ var _login_modal_erb__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_login_modal_erb__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var pages_session_components_registration_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21927);












/***/ }),

/***/ 56797:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/modals/not_premium_user_modal/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/modals/not_premium_user_modal/index.js



/***/ }),

/***/ 11971:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ NotSubscribedUserModal)
/* harmony export */ });
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9570);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71261);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10083);
/* harmony import */ var _images_thinking_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66382);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87322);





class NotSubscribedUserModal {
    currentResourceRestricted(flagValues) {
        const { title, description, cta_text, cta_link, btn_text } = flagValues;
        utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].populate */ .Z.populate('#js-not-subscribed-user-modal', {
            title,
            description,
            cta_text,
            btn_text
        });
        utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].open */ .Z.open('#js-not-subscribed-user-modal');
        this.createLink(cta_link);
    }
    createLink(link) {
        window.jQuery('a.not-subscribed-user-modal-btn').attr('href', link);
    }
    constructor($element, resourceRestricted){
        this.flagValues = window.jQuery($element).data('flagModalRestriction');
        this.currentResourceRestricted(this.flagValues[resourceRestricted]);
    }
}



/***/ }),

/***/ 23639:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61094);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81742);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_cta_erb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29404);
/* harmony import */ var _components_cta_erb__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_cta_erb__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_cookie_manager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88526);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87322);
/* harmony import */ var images_pay_wall_hourglass_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76506);






class PaywallModal {
    dismissModal() {
        utils_cookie_manager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].setExpirationCookie */ .Z.setExpirationCookie(this.cookieName, true, this.$context.data('daysExpires'));
    }
    bind() {
        if (this.$context.data('show') && !utils_cookie_manager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCookie */ .Z.getCookie(this.cookieName)) {
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].open */ .Z.open('#js-paywall-modal');
        }
    }
    bindDismiss() {
        this.$btnDismiss.on('click', ()=>this.dismissModal());
    }
    constructor($context){
        this.$context = $context;
        this.cookieName = 'renewal_paywall';
        this.$btnDismiss = window.jQuery('.js-paywall-renewall-dismiss', this.$context);
        this.bind();
        this.bindDismiss();
    }
}
const init = ()=>new PaywallModal(window.jQuery('#js-paywall-modal'));
document.addEventListener('turbolinks:load', ()=>init());
init();


/***/ }),

/***/ 42451:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4381);



/***/ }),

/***/ 82607:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39285);



/***/ }),

/***/ 49689:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _area_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4571);
/* harmony import */ var _area_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_area_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18603);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63053);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _redirect_erb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2231);
/* harmony import */ var _redirect_erb__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_redirect_erb__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87322);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





const MAPPING_PRODUCTS = {
    concursos: 'Concurso Público',
    militares: 'Forças Armadas',
    oab: 'OAB',
    vestibular: 'ENEM e Vestibular'
};
class Setup {
    constructor(){
        this.open = ()=>{
            if (!this.$context.get(0)) {
                return;
            }
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].open */ .Z.open(this.$context);
            window.UserTracker.emit('event', {
                eventName: 'account setup started',
                data: {
                    platform: this.platform,
                    feature_version: this.feature_version,
                    request_path: window.location.pathname
                }
            });
        };
        this.bindEvents = ()=>{
            this.$buttons.on('click', (e)=>{
                e.preventDefault();
                // toggle class "selected"
                this.$buttons.each((idx)=>window.jQuery(this.$buttons[idx]).removeClass('selected'));
                window.jQuery(e.currentTarget).addClass('selected');
                this.$selected = window.jQuery(e.currentTarget);
                this.bindSelected();
                this.bindRedirect();
            });
        };
        this.bindRedirect = ()=>{
            var _this = this;
            this.$buttonsOptions.on('click', /*#__PURE__*/ _async_to_generator(function*(e) {
                e.preventDefault();
                const params = new URLSearchParams(window.location.search);
                const current = window.jQuery(e.currentTarget);
                const currentData = current.data();
                window.UserTracker.emit('event', {
                    eventName: 'account setup completed',
                    data: {
                        'first action chosen': currentData.option,
                        platform: _this.platform,
                        feature_version: _this.feature_version,
                        request_path: window.location.pathname,
                        segment: MAPPING_PRODUCTS[_this.$selected.data().product]
                    }
                });
                const redirect = currentData.redirect;
                const _blank = currentData.blank;
                if (redirect.includes('app.qconcursos.com')) {
                    const user_preferences = {
                        default_environment: 'ils'
                    };
                    _this.bindDefaultEnvironment(user_preferences);
                    if (_this.$loadingContent) {
                        _this.$areaContent.addClass('hidden');
                        _this.$redirectContent.addClass('hidden');
                        if (!redirect) {
                            _this.$redirectContent.addClass('hidden');
                        }
                        _this.$loadingContent.removeClass('hidden');
                        setTimeout(()=>{
                            if (_blank) {
                                window.open(redirect, '_blank');
                            } else {
                                window.Turbolinks.visit(redirect);
                            }
                        }, 2000);
                        return;
                    }
                }
                if (redirect || params.get('return_url')) {
                    if (_blank) {
                        window.open(redirect === '' || redirect === null ? params.get('return_url') : redirect, '_blank');
                    } else {
                        window.Turbolinks.visit(redirect === '' || redirect === null ? params.get('return_url') : redirect);
                    }
                }
                utils_modal_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].close */ .Z.close(_this.$context);
            }));
        };
        this.bindDefaultEnvironment = /*#__PURE__*/ _async_to_generator(function*(user_preferences) {
            yield Thor.UserPreference.update({}, {
                data: {
                    user_preferences
                }
            });
        });
        this.bindSelected = ()=>{
            if (this.$selected) {
                this.$btnNextStep.removeAttr('disabled');
            }
        };
        this.bindNextStep = ()=>{
            this.$btnNextStep.on('click', (e)=>{
                e.preventDefault();
                this.bindPreferences(this.$selected.data().product);
                window.UserTracker.emit('event', {
                    eventName: 'account setup preferences setted',
                    data: {
                        platform: this.platform,
                        feature_version: this.feature_version,
                        request_path: window.location.pathname,
                        segment: MAPPING_PRODUCTS[this.$selected.data().product]
                    }
                });
                this.$areaContent.addClass('hidden');
                this.$redirectContent.removeClass('hidden');
                this.handleVisibleButton();
            });
        };
        this.handleVisibleButton = ()=>{
            const selectedProduct = this.$selected.data().product;
            this.$buttonsOptions.each(function() {
                var _$_data;
                const compatibleProducts = ((_$_data = window.jQuery(this).data('segment')) == null ? void 0 : _$_data.split(',')) || [];
                compatibleProducts.includes(selectedProduct) ? window.jQuery(this).show() : window.jQuery(this).hide();
            });
        };
        this.getProduct = (key)=>{
            return this.products.find((item)=>item.key === key);
        };
        this.getProductId = (key)=>{
            const product = this.getProduct(key);
            return product == null ? void 0 : product.id;
        };
        var _this = this;
        this.bindPreferences = /*#__PURE__*/ _async_to_generator(function*(product) {
            const user_preferences = {
                chose_product: true,
                preferred_product_id: _this.getProductId(product)
            };
            try {
                yield Thor.UserPreference.update({}, {
                    data: {
                        user_preferences
                    }
                });
                toastr.success('Preferências salvas com sucesso!');
            } catch (err) {
                const message = 'Tivemos um problema ao tentar enviar suas preferências!';
                toastr.error(message);
                Rollbar.error(message, err);
            }
        });
        this.$context = window.jQuery('#js-setup');
        this.$productTypes = window.jQuery('#products', this.$context);
        this.$buttons = window.jQuery('#products > button', this.$context);
        this.$buttonsOptions = window.jQuery('#options > button', this.$context);
        this.$btnNextStep = window.jQuery('#btnSetupNextStep', this.$context);
        this.$areaContent = window.jQuery('#area', this.$context);
        this.$redirectContent = window.jQuery('#redirect', this.$context);
        this.$loadingContent = window.jQuery('#loading', this.$context);
        this.$selected = null;
        if (!this.$context.get(0)) {
            return;
        }
        this.products = this.$productTypes.data('products');
        this.platform = 'web';
        this.feature_version = '3.0.2';
        this.bindEvents();
        this.bindNextStep();
    }
}
(()=>{
    document.addEventListener('turbolinks:load', function() {
        const setupModal = new Setup();
        setupModal.open();
    });
})();


/***/ }),

/***/ 84546:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _images_banner_bb_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42888);
/* harmony import */ var _images_banner_smart_jpg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80631);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53473);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98222);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89506);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


// import './images/banner-tech.jpg';



const init = ()=>{
    const $segmentButton = window.jQuery('#newMenu .segment-button');
    const $segmentNewMenu = window.jQuery('#segmentNewMenu');
    const $headerButtons = window.jQuery('.nav_header_link_menu:not(div)');
    const $headerSubButtons = window.jQuery('.nav_header_submenu');
    $segmentButton.off('click').on('click', (e)=>{
        window.jQuery('#segmentNewMenu').toggle();
        if (window.jQuery(e.currentTarget).hasClass('active')) {
            window.jQuery(e.currentTarget).removeClass('active');
        } else {
            window.jQuery(e.currentTarget).addClass('active');
            window.dataLayer.push({
                event: 'click_menu_header',
                menu_item: window.jQuery(e.currentTarget).find('span').text()
            });
        }
    });
    $headerButtons.off('click').on('click', ()=>{
        var _window;
        if ((_window = window) == null ? void 0 : _window.dataLayer) {
            var _$;
            window.dataLayer.push({
                event: 'click_menu_header',
                menu_item: (_$ = window.jQuery(undefined)) == null ? void 0 : _$.text()
            });
        }
    });
    $headerSubButtons.off('click').on('click', (e)=>{
        var _window;
        if ((_window = window) == null ? void 0 : _window.dataLayer) {
            var _this, _$, _$1;
            var _$_text;
            window.dataLayer.push(_extends({
                event: 'click_submenu_header',
                menu_item: (_this = (_$_text = (_$ = window.jQuery(e.target)) == null ? void 0 : _$.text()) != null ? _$_text : (_$1 = window.jQuery(e.target)) == null ? void 0 : _$1.html()) == null ? void 0 : _this.trim()
            }, window.jQuery(e.target).attr('data-parent') && {
                parent_item: window.jQuery(e.target).attr('data-parent')
            }, window.jQuery(e.target).attr('data-category') && {
                category_item: window.jQuery(e.target).attr('data-category')
            }));
        }
    });
    window.jQuery(document).on('click', (e)=>{
        if (!$segmentButton.is(e.target) && $segmentButton.has(e.target).length === 0 && !$segmentNewMenu.is(e.target) && $segmentNewMenu.has(e.target).length === 0) {
            $segmentNewMenu.hide();
            $segmentButton.removeClass('active');
        }
    });
};
document.addEventListener('turbolinks:load', ()=>init());
init();


/***/ }),

/***/ 81790:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/notification_bar/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/notification_bar/index.js

(function($) {
    'use strict';
    const sendEmail = ($button)=>{
        Thor.User.send_email_confirmation({
            user_id: currentUser.id
        }, {}).then(()=>{
            $button.parent().html($button.data('already-sent'));
        });
    };
    $(document).off('click.notification_bar_button', '.js-send-email').on('click.notification_bar_button', '.js-send-email', (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const $button = $(event.currentTarget);
        sendEmail($button);
    });
})(window.jQuery);


/***/ }),

/***/ 48023:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/outdated_browser/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/outdated_browser/index.js



/***/ }),

/***/ 6746:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/pagination/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/pagination/index.js



/***/ }),

/***/ 98290:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24570);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96320);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),

/***/ 24246:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export default */
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83207);

class Share {
    clip(context) {
        window.jQuery('.js-cliped', context).addClass('active');
        setTimeout(function() {
            window.jQuery('.js-cliped', context).removeClass('active');
        }, 300);
    }
    clippingCopyLink(context) {
        const $copyLinkUrl = window.jQuery('.js-share-copy-link-input', context);
        const itemUrl = $copyLinkUrl[0].value;
        $copyLinkUrl[0].value = itemUrl;
        $copyLinkUrl.select();
        document.execCommand('copy');
    }
    bindCopy() {
        const self = this;
        window.jQuery('.js-share-copy-link', this.$context).click(function() {
            self.clippingCopyLink(this);
            self.clip(this);
        });
    }
    constructor(){
        this.$context = '.q-share-widget';
        this.bindCopy();
    }
}



/***/ }),

/***/ 73944:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./components/smart_banner/images/appstore_icon.png
var appstore_icon = __webpack_require__(69394);
// EXTERNAL MODULE: ./components/smart_banner/images/play_icon.png
var play_icon = __webpack_require__(32818);
;// CONCATENATED MODULE: ./components/smart_banner/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/smart_banner/index.js





/***/ }),

/***/ 20592:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./components/sticky_cta_menu/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/sticky_cta_menu/index.js



/***/ }),

/***/ 50058:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _images_header_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33269);
/* harmony import */ var _images_red_header_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13680);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81732);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72500);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_cookie_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88526);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87322);






class SubscriptionExpirationModal {
    bind() {
        const isModalHidden = !this.$context.hasClass('open');
        const hasClosedModalToday = utils_cookie_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getCookie */ .Z.getCookie(this.cookieName);
        if (isModalHidden && !hasClosedModalToday) {
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_5__/* ["default"].open */ .Z.open('#js-time-box-modal');
        }
        this.bindClose();
        this.bindVisit();
    }
    bindClose() {
        this.$context.find('.btn-default').on('click', ()=>{
            utils_cookie_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].setExpirationCookie */ .Z.setExpirationCookie(this.cookieName, true, 1);
            this.$context.removeClass('open');
            UserTracker.emit('event', {
                eventName: 'UI Interaction',
                data: {
                    context: 'renewal timebox modal',
                    type: 'close',
                    action: 'click'
                }
            });
        });
    }
    bindVisit() {
        this.$context.find('.btn-info').on('click', ()=>{
            utils_cookie_manager__WEBPACK_IMPORTED_MODULE_4__/* ["default"].setExpirationCookie */ .Z.setExpirationCookie(this.cookieName, true, 1);
            UserTracker.emit('event', {
                eventName: 'UI Interaction',
                data: {
                    context: 'renewal timebox modal',
                    type: 'link',
                    action: 'click'
                }
            });
        });
    }
    constructor(){
        this.$context = window.jQuery('#js-time-box-modal');
        this.cookieName = 'renewal_timebox';
        if (!this.$context.length) {
            return false;
        }
        this.bind();
    }
}
(()=>{
    document.addEventListener('turbolinks:load', ()=>{
        new SubscriptionExpirationModal();
    });
})();


/***/ }),

/***/ 40390:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ./components/trial/modal/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/trial/modal/form/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/input_mask/index.js
var input_mask = __webpack_require__(68302);
;// CONCATENATED MODULE: ./pages/checkout/components/checkout_payment/utils/getCardFlag.js
function getCardFlag(cardNumber) {
    const cards = {
        visa: cardNumber >= 40 && cardNumber < 50,
        master: cardNumber >= 51 && cardNumber <= 55,
        amex: cardNumber >= 34 && cardNumber <= 37,
        elo: cardNumber >= 50 && cardNumber <= 69
    };
    for(var flag in cards){
        if (cards[flag]) {
            return flag;
        }
    }
    return false;
}
/* harmony default export */ const utils_getCardFlag = (getCardFlag);

;// CONCATENATED MODULE: ./pages/checkout/components/checkout_payment/services/credit_card.js
/* eslint-disable no-undef */ 
/* harmony default export */ const credit_card = ({
    getIssuer (ccNumber) {
        return new Promise((resolve, reject)=>{
            const firstTwoNumbers = ccNumber.replace(/[ .-]/g, '').slice(0, 2);
            const getFlagByNumber = utils_getCardFlag(firstTwoNumbers);
            const binNumber = ccNumber.replace(/[ .-]/g, '').slice(0, 6);
            Mercadopago.getPaymentMethod({
                bin: binNumber
            }, (status, res)=>{
                if (status === 200) {
                    if (res.length > 1) {
                        const hasMasterAndEloInResults = res.every((method)=>method.id === 'master' || method.id === 'elo');
                        if (hasMasterAndEloInResults && getFlagByNumber) {
                            resolve(getFlagByNumber);
                        }
                    }
                    const issuer = res[0].id;
                    gon.cardIssuer = issuer;
                    resolve(issuer);
                } else {
                    reject(res.message);
                }
            });
        });
    },
    getInstallments (number, amount) {
        return new Promise((resolve, reject)=>{
            const bin = number.replace(/[ .-]/g, '').slice(0, 6);
            window.Mercadopago.getInstallments({
                bin,
                amount
            }, (status, res)=>{
                if (status === 200) {
                    resolve(res[0]);
                } else {
                    reject(res.message);
                }
            });
        });
    },
    generateToken (form) {
        return new Promise((resolve, reject)=>{
            Mercadopago.clearSession();
            Mercadopago.createToken(form, (status, response)=>{
                if (response.error) {
                    const err = new Error(response.error);
                    err.errors = response.cause;
                    return reject(err);
                } else {
                    return resolve(response.id);
                }
            });
        });
    },
    mapErrorsToFields (errors) {
        return errors.map((e)=>this.getError(e.code));
    },
    getError (errorCode) {
        switch(errorCode){
            case 'cc_rejected_bad_filled_card_number':
                return {
                    field: 'number',
                    message: 'Número de cartão inválido'
                };
            case 'E301':
                return {
                    field: 'number',
                    message: 'Número de cartão inválido'
                };
            case '205':
                break; // parameter cardNumber can not be null/empty
            case 'cc_rejected_bad_filled_date':
                return {
                    field: 'expiration',
                    message: 'Data de vencimento inválida'
                };
            case '208':
                return {
                    field: 'expiration',
                    message: 'Data de vencimento inválida'
                };
            case '325':
                return {
                    field: 'expiration',
                    message: 'Data de vencimento inválida'
                };
            case '209':
                return {
                    field: 'expiration',
                    message: 'Data de vencimento inválida'
                };
            case '326':
                return {
                    field: 'expiration',
                    message: 'Data de vencimento inválida'
                };
            case '212':
                break; // parameter docType can not be null/empty.
            case '213':
                break; // The parameter cardholder.document.subtype can not be null or empty.
            case '214':
                break; // parameter docNumber can not be null/empty.
            case '322':
                break; // invalid parameter docType.
            case '323':
                break; // Invalid parameter cardholder.document.subtype.
            case '324':
                return {
                    field: 'cpf',
                    message: 'CPF inválido'
                };
            case '220':
                return {
                    field: 'issuer',
                    message: 'Banco emissor inválido'
                };
            case '221':
                return {
                    field: 'name',
                    message: 'Nome do titular do cartão inválido'
                };
            case '316':
                return {
                    field: 'name',
                    message: 'Nome do titular do cartão inválido'
                };
            case 'cc_rejected_bad_filled_security_code':
                return {
                    field: 'cvv',
                    message: 'Código de segurança inválido'
                };
            case '224':
                break; // parameter securityCode can not be null/empty.
            case 'E302':
                return {
                    field: 'cvv',
                    message: 'Código de segurança inválido'
                };
            default:
                return null;
        }
    },
    getBank (ccNumber) {
        // Just nubank for now
        const bin = ccNumber.replace(/[ .-]/g, '').slice(0, 6);
        const nubankBins = [
            '550209',
            '516220',
            '523421',
            '554865',
            '230540',
            '230721',
            '516292',
            '516230',
            '522688',
            '525361',
            '520048'
        ];
        return nubankBins.includes(bin.toString()) ? 'nubank' : 'other';
    }
});

;// CONCATENATED MODULE: ./pages/checkout/components/checkout_payment/services/order.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const SUCCESS_STATUSES = [
    'issued',
    'paid',
    'approved',
    'authorized'
];
const PROCESSING_STATUSES = [
    'pending_contingency',
    'pending_review_manual'
];
/* harmony default export */ const order = ({
    create ({ cart, token, customer }) {
        return _async_to_generator(function*() {
            const { email, name } = customer || {};
            try {
                return email ? yield Thor.GuestOrders.create({}, {
                    data: {
                        cart,
                        user: {
                            name,
                            email
                        },
                        challenges: {
                            token
                        }
                    }
                }) : yield Thor.Order.create({}, {
                    data: {
                        cart
                    }
                });
            } catch (err) {
                var _response_responseJSON, _response_responseJSON1;
                const { response } = err;
                if ((response == null ? void 0 : response.status) === 422 && (response == null ? void 0 : (_response_responseJSON = response.responseJSON) == null ? void 0 : _response_responseJSON.error) === 'Cart not found for user') {
                    throw new Error('Cart not found');
                }
                err.errors = response == null ? void 0 : (_response_responseJSON1 = response.responseJSON) == null ? void 0 : _response_responseJSON1.errors;
                throw err;
            }
        })();
    },
    pay (orderNumber, paymentForm = {}, isTrial = false) {
        return _async_to_generator(function*() {
            var _paymentForm_customer;
            const email = paymentForm == null ? void 0 : (_paymentForm_customer = paymentForm.customer) == null ? void 0 : _paymentForm_customer.email;
            try {
                var _paymentForm_card;
                const payment = isTrial ? yield Thor.TrialPlans.create({}, {
                    data: {
                        attributes: paymentForm
                    }
                }) : email ? yield Thor.GuestOrdersPayments.create({
                    order_number: orderNumber
                }, {
                    data: paymentForm
                }) : yield Thor.Order.pay({
                    order_number: orderNumber
                }, {
                    data: paymentForm
                });
                const selectPaymentType = paymentForm.payment.type;
                const paymentTypes = {
                    CreditCardPayment: payment.credit_card_payment || payment.payment,
                    PixPayment: payment.pix_payment,
                    TicketPayment: payment.ticket_payment,
                    BnplPayment: payment.bnpl_payment
                };
                const usedPayment = paymentTypes[selectPaymentType];
                // Nupay fallback
                const nupayFallbackAllowed = gon.fallback_nubank && (paymentForm == null ? void 0 : (_paymentForm_card = paymentForm.card) == null ? void 0 : _paymentForm_card.bank) === 'nubank' && (usedPayment == null ? void 0 : usedPayment.status) === 'rejected';
                if (nupayFallbackAllowed) {
                    return payment;
                }
                if (!SUCCESS_STATUSES.includes(usedPayment.status) && !PROCESSING_STATUSES.includes(usedPayment.status_detail)) {
                    const err = new Error(usedPayment[gon.flags.modal_error_checkout ? 'status_detail' : 'gateway_issue_message']);
                    err.alert = true;
                    throw err;
                }
                return payment;
            } catch (err) {
                var _response_responseJSON;
                const { response } = err;
                err.errors = response == null ? void 0 : (_response_responseJSON = response.responseJSON) == null ? void 0 : _response_responseJSON.errors;
                throw err;
            }
        })();
    }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(88414);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./utils/validator/index.js
var validator = __webpack_require__(91337);
// EXTERNAL MODULE: ./utils/stimulus/index.js
var stimulus = __webpack_require__(40225);
;// CONCATENATED MODULE: ./pages/checkout/utils/form-validation/index.js
/**
 * Validação de CPF
 *
 * Utilizado pela Receita Federal, adaptado para passar na
 * nossa configuração de eslint/prettier.
 *
 * http://www.receita.fazenda.gov.br/aplicacoes/atcta/cpf/funcoes.js
 */ function CpfVerify(cpf) {
    const strCPF = cpf.replace(/\D/g, '');
    let soma = 0;
    let resto;
    const invalidNumbers = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999'
    ];
    if (strCPF.length !== 11 || invalidNumbers.includes(strCPF)) {
        return false;
    }
    for(let i = 1; i <= 9; i++){
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    resto = soma * 10 % 11;
    if (resto === 10 || resto === 11) {
        resto = 0;
    }
    if (resto !== parseInt(strCPF.substring(9, 10))) {
        return false;
    }
    soma = 0;
    for(let i = 1; i <= 10; i++){
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    }
    resto = soma * 10 % 11;
    if (resto === 10 || resto === 11) {
        resto = 0;
    }
    if (resto !== parseInt(strCPF.substring(10, 11))) {
        return false;
    }
    return true;
}
function CepVerify(cep) {
    const cepRegex = /^[0-9]{5}-[0-9]{3}$/;
    const cepWithoutSpaces = cep.trim();
    return cepRegex.test(cepWithoutSpaces);
}

;// CONCATENATED MODULE: ./pages/checkout/components/checkout_error_modal/errorMessages.js
const GENERIC_ERROR = {
    title: 'Ocorreu um erro no pagamento!',
    message: 'Houve um erro ao processar sua compra. Tente novamente mais tarde ou utilize outra forma de pagamento.'
};
const GENERIC_CC_ERROR = {
    title: 'Ocorreu um erro no pagamento!',
    message: 'Houve um erro ao processar sua compra. Tente novamente com outro cartão ou utilize outra forma de pagamento.'
};
const GENERIC_BNPL_ERROR = {
    title: 'Ocorreu um erro!',
    message: 'Por favor, recarregue a página de tente novamente. Caso o erro persista, entre em contato com o nosso suporte.'
};
const errorMapping = {
    cc_rejected_other_reason: GENERIC_CC_ERROR,
    cc_rejected_blacklist: GENERIC_CC_ERROR,
    cc_rejected_card_error: GENERIC_CC_ERROR,
    cc_rejected_high_risk: GENERIC_CC_ERROR,
    cc_rejected_bad_filled_card_number: {
        title: 'Número do cartão inválido!',
        message: 'O número do cartão parece estar incorreto.<br>Revise com atenção os dados preenchidos e tente novamente.'
    },
    cc_rejected_bad_filled_date: {
        title: 'Data de vencimento inválida!',
        message: 'O pagamento não foi processado. Revise com atenção os dados de validade do cartão e tente novamente.'
    },
    cc_rejected_bad_filled_other: {
        title: 'Dados do cartão inválidos!',
        message: 'As informações do cartão estão incorretas. Revise com atenção os dados preenchidos e tente novamente.'
    },
    cc_rejected_bad_filled_security_code: {
        title: 'Código de segurança inválido!',
        message: 'Seu pagamento não foi processado. Revise com atenção o código de segurança e tente novamente.'
    },
    cc_rejected_call_for_authorize: {
        title: 'Pagamento não autorizado!',
        message: 'Entre em contato com o banco para autorizar a compra e tente novamente. Você também pode tentar utilizar outro cartão ou outra forma de pagamento.'
    },
    cc_rejected_card_disabled: {
        title: 'Este cartão não está ativo!',
        message: 'Parece que este cartão ainda não foi ativado. Entre em contato com o banco para ativá-lo, ou tente novamente utilizando outro cartão.'
    },
    cc_rejected_duplicated_payment: {
        title: 'Pagamento duplicado!',
        message: 'Identificamos um pagamento recente no mesmo valor. Aguarde alguns minutos e tente novamente.'
    },
    cc_rejected_insufficient_amount: {
        title: 'Este cartão não possui limite!',
        message: 'O cartão utilizado não possui saldo suficiente pra efetuar a compra. Tente novamente usando outro cartão ou outra forma de pagamento.'
    },
    cc_rejected_invalid_installments: {
        title: 'Ocorreu um erro no pagamento!',
        message: 'Este cartão não permite o número de parcelas escolhido. Tente novamente com outro cartão ou utilize outra forma de pagamento.'
    },
    cc_rejected_max_attempts: {
        title: 'Limite de tentativas excedido!',
        message: 'Você atingiu o limite de tentativas neste cartão. Tente novamente com outro cartão ou utilize outra forma de pagamento.'
    },
    payer_unavailable: {
        title: 'Ocorreu um erro no pagamento!',
        message: 'O pagamento não foi processado. Entre em contato com o nosso suporte para que possamos ajudar você!'
    },
    session_expired: {
        title: 'Sessão expirada!',
        message: 'Ops, sua sessão expirou! Atualize sua página e selecione o produto desejado novamente.'
    },
    rejected_by_bank: {
        title: 'Pagamento rejeitado!',
        message: 'Seu pagamento não foi aprovado pelo banco. Tente novamente com outra forma de pagamento.'
    },
    bnpl_fraud_id: GENERIC_BNPL_ERROR,
    bnpl_api_error: GENERIC_BNPL_ERROR,
    access_denied: {
        title: 'Não foi possível concluir a autorização',
        message: 'Verificamos o CPF informado e não conseguimos encontrar sua autorização no Nubank.'
    },
    unauthorized_client: {
        title: 'Não foi possível concluir a autorização',
        message: 'Verificamos o CPF informado e não conseguimos encontrar sua conta no Nubank.'
    },
    unavaliable_payment_conditions: {
        title: 'Não encontramos meios de pagamento disponíveis',
        message: 'O meio de pagamento Nubank não está disponível para este CPF. Tente novamente com outro meio de pagamento ou com outro CPF.'
    },
    nupay_auth_server_error: {
        title: 'Não conseguimos finalizar sua solicitação',
        message: 'Aguarde alguns instantes e tente novamente. Caso o erro persista, entre em contato com o nosso suporte.'
    },
    transaction_failed: {
        title: 'Não foi possível concluir a autorização',
        message: 'Devido a falta de saldo suficiente e limite de crédito na sua conta do Nubank, não conseguimos concluir a autorização.'
    },
    invalid_grant: {
        title: 'Não foi possível concluir a autorização',
        message: 'Não identificamos sua autorização'
    },
    invalid_client: {
        title: 'Não foi possível concluir a autorização',
        message: 'Verifique os dados informados e tente novamente.'
    },
    invalid_request: {
        title: 'Não foi possível concluir',
        message: 'Verifique os dados informados e tente novamente.'
    },
    invalid_scope: {
        title: 'Não foi possível concluir',
        message: 'Verifique os dados informados e tente novamente.'
    },
    server_error: {
        title: 'Não foi possível concluir',
        message: 'Verifique os dados informados e tente novamente.'
    },
    temporarily_unavailable: {
        title: 'Não foi possível concluir',
        message: 'Verifique os dados informados e tente novamente.'
    },
    bnpl_koin_error: {
        title: 'Ocorreu um erro!',
        message: null
    },
    bnpl_wrong_input: {
        title: 'Ocorreu um erro no Preenchimento!',
        message: 'Preencha todos os campos corretamente e tente de novo.'
    },
    coupon_invalid: {
        title: 'Cupom inválido!',
        message: 'Este cupom está inválido. Tente utilizar outro.'
    },
    coupon_invalid_for_offer: {
        title: 'Cupom inválido!',
        message: 'Este cupom não é válido para essa oferta.'
    },
    coupon_expired: {
        title: 'Promoção encerrada!',
        message: 'Este cupom não está mais disponível porque a promoção já foi encerrada. Tente utilizar um cupom promocional ativo'
    },
    coupon_redeemed: {
        title: 'Cupom de desconto esgotado!',
        message: 'Parece que todos os cupons disponíveis para esta promoção já foram utilizados. Tente utilizar um cupom ainda ativo.'
    },
    coupon_referral_self: {
        title: 'Você não pode utilizar este cupom!',
        message: 'Seu cupom de desconto só pode ser utilizado por outros alunos. Tente utilizar um outro cupom.'
    },
    coupon_remove_error: {
        title: 'Houve um erro ao remover o cupom.',
        message: 'Atualize a página e tente novamente.'
    },
    coupon_global_monthly: {
        title: 'Cupom não aplicável nesta oferta!',
        message: 'Esse cupom não é válido para ofertas mensais. Você pode aplicá-lo em outras ofertas.'
    },
    coupon_already_used: {
        title: 'Cupom já utilizado!',
        message: 'Esse cupom só permite 1 uso por aluno.'
    }
};

;// CONCATENATED MODULE: ./components/trial/modal/form/index.js
function form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function form_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









const { validate } = validator/* default */.Z;
class TrialFormController extends stimulus/* Controller */.Q {
    set loading(status) {
        const method = status ? 'add' : 'remove';
        this.submitButtonTarget.classList[method]('submit-button--loading');
    }
    get number() {
        const { value } = this.numberTarget;
        return value ? value.replace(/ /gi, '') : null;
    }
    get expiration() {
        return this.expirationTarget.value || '';
    }
    get expirationMonth() {
        return this.expirationMonthTarget.value;
    }
    set expirationMonth(value) {
        this.expirationMonthTarget.value = value;
    }
    get expirationYear() {
        return this.expirationYearTarget.value;
    }
    set expirationYear(value) {
        this.expirationYearTarget.value = value;
    }
    get expirationDate() {
        const parts = this.expiration.split('/');
        if (parts.length < 2) {
            return null;
        }
        const month = parseInt(parts[0]) - 1;
        if (month < 0 || month > 11) {
            return null;
        }
        const year = parseInt(`20${parts[1]}`);
        return new Date(year, month);
    }
    set issuer(value) {
        this.issuerTarget.value = value;
    }
    connect() {
        this.on('updateOffer', this.updateOffer.bind(this));
        this.setupValidator();
    }
    updateOffer(offer) {
        this.offerNameTarget.innerHTML = `Plano ${offer.offerName}`;
        this.offerPriceTarget.innerHTML = offer.offerPrice;
        this.offerIdTarget.value = offer.offerId;
        this.trialDaysTarget.innerHTML = `${gon.flags.trial_settings.days} dias`;
        this.element.querySelector('.subscription-icon').setAttribute('class', `subscription-icon subscription-icon--${offer.offerSubscription}`);
    }
    setupValidator() {
        this.formTarget.addEventListener('change', (event)=>{
            if (event.target.matches('input')) {
                this.toggleSubmitButtonDisabledProp(this.formTarget);
            }
        });
        const errorHandler = (field)=>{
            this.toggleSubmitButtonDisabledProp(field.closest('form'));
        };
        validator/* default.init */.Z.init({
            afterShowError: errorHandler,
            afterRemoveError: errorHandler
        });
    }
    toggleSubmitButtonDisabledProp(form) {
        const submit = this.submitButtonTarget;
        if (!submit) {
            return;
        }
        const errors = form.querySelectorAll('.has-error');
        if (errors.length > 0 || this.isAnyRequiredFieldNotFilled(form)) {
            submit.setAttribute('disabled', 'disabled');
        } else {
            submit.removeAttribute('disabled');
        }
    }
    isAnyRequiredFieldNotFilled(form) {
        let result = true;
        form.querySelectorAll('[required]').forEach(function(item) {
            if (!result) {
                return;
            }
            if (!item.value) {
                result = false;
            }
        });
        return !result;
    }
    onExpirationDateChange() {
        const date = this.expirationDate;
        const isDateValid = this.validateExpirationDate();
        this.expirationMonth = isDateValid ? date.getMonth() + 1 : '';
        this.expirationYear = isDateValid ? date.getFullYear() : '';
    }
    onNameChange() {
        const isFullName = /^[a-zA-Z]+ [a-zA-Z]+/;
        const nameValue = this.nameTarget.value;
        if (!isFullName.test(nameValue)) {
            validate.showError(this.nameTarget, 'Adicione ao menos um sobrenome');
        } else {
            validate.removeError(this.nameTarget);
        }
    }
    onCpfVerify() {
        const cpfValue = this.cpfTarget.value;
        if (!CpfVerify(cpfValue)) {
            validate.showError(this.cpfTarget, 'CPF inválido');
        } else {
            validate.removeError(this.cpfTarget);
        }
    }
    onNumberChange() {
        var _this = this;
        return form_async_to_generator(function*() {
            if (!_this.validateNumber()) {
                return;
            }
            let err, issuer;
            // eslint-disable-next-line no-undef
            [err, issuer] = yield withError(credit_card.getIssuer(_this.number));
            if (err) {
                return _this.handleSubmitErrors(err);
            }
            _this.issuer = issuer;
        })();
    }
    validateNumber() {
        if (this.number && this.number.trim() !== '' && this.number.length >= 6) {
            return true;
        }
        this.issuer = null;
        return false;
    }
    onSubmit(event) {
        var _this = this;
        return form_async_to_generator(function*() {
            event.preventDefault();
            _this.loading = true;
            _this.hideErrorMessage();
            let err, data;
            // eslint-disable-next-line no-undef
            [err, data] = yield withError(_this.getSubmitData(event.target));
            if (err) {
                return _this.handleSubmitErrors(err);
            }
            // eslint-disable-next-line no-undef
            [err] = yield withError(order.pay(null, data, true));
            if (err) {
                return _this.handleSubmitErrors(err);
            }
            _this.loading = false;
            _this.trigger('trial-modal->goToSuccess');
        })();
    }
    getSubmitData(form) {
        var _this = this;
        return form_async_to_generator(function*() {
            const data = window.jQuery(form).serializeObject();
            data.payment = data.payment || {};
            data.payment.type = 'CreditCardPayment';
            data.payment.agreed_to_terms = 'on';
            data.payment.installments = 1;
            // eslint-disable-next-line no-undef
            const [err, token] = yield withError(credit_card.generateToken(_this.formTarget));
            if (err) {
                throw err;
            }
            data.card.token = token;
            return data;
        })();
    }
    validateExpirationDate() {
        const parts = this.expiration.split('/');
        const month = parseInt(parts[0]);
        const today = new Date();
        if (!this.expirationDate || this.expirationDate < today || month > 12 || month < 1) {
            setTimeout(()=>validate.showError(this.expirationTarget, 'Data de vencimento inválida.'), 200);
            return false;
        }
        validate.removeError(this.expirationTarget);
        return true;
    }
    handleSubmitErrors(err) {
        this.loading = false;
        if (err.alert === true) {
            return this.showErrorMessage(err.message);
        }
        if (err === 'payment method not found') {
            return this.setFieldsErrors([
                credit_card.getError('E301')
            ]);
        }
        if (err.errors && err.errors instanceof Array) {
            const mappedErrors = err.errors.map((e)=>credit_card.getError(e.code)).filter((x)=>!!x);
            const res = uniqBy_default()(mappedErrors, (x)=>x.field);
            return this.setFieldsErrors(res);
        }
        this.showErrorMessage();
    }
    setFieldsErrors(errors) {
        setTimeout(()=>{
            errors.forEach((e)=>{
                const node = this[`${e.field}Target`];
                validator/* default.validate.showError */.Z.validate.showError(node, e.message);
            });
        }, 100);
    }
    showErrorMessage(code) {
        var _errorMapping_code;
        const genericMessage = 'Houve um erro ao processar sua compra. Tente novamente mais tarde ou use outro cartão.';
        const message = ((_errorMapping_code = errorMapping[code]) == null ? void 0 : _errorMapping_code.message) || genericMessage;
        this.errorMessageTarget.textContent = message;
        this.errorMessageTarget.classList.add('error-message--show');
    }
    hideErrorMessage() {
        this.errorMessageTarget.classList.remove('error-message--show');
    }
}
TrialFormController.targets = [
    'offerName',
    'offerPrice',
    'offerId',
    'trialDays',
    'form',
    'issuer',
    'number',
    'expiration',
    'expirationMonth',
    'expirationYear',
    'name',
    'cpf',
    'cvv',
    'submitButton',
    'errorMessage'
];


;// CONCATENATED MODULE: ./components/trial/modal/offers/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/trial/modal/offers/index.js


class TrialOffersController extends stimulus/* Controller */.Q {
    connect() {
        this.selected = null;
        this.offer = null;
        this.on('setInitialOffer', this.setInitialOffer.bind(this));
    }
    setInitialOffer(offer) {
        this.offer = offer;
        const { offerName, offerPrice, offerFeatures, offerSubscription } = this.offer;
        this.element.setAttribute('class', `q-trial-offers q-trial-offers--${offerSubscription}`);
        this.nameTarget.textContent = offerName;
        this.priceTarget.textContent = offerPrice;
        this.featuresTarget.innerHTML = offerFeatures.split(/true|false/).filter((feature)=>!!feature).map((feature)=>`<li><i class="q-icon q-icon-check"></i><p>${feature}</p></li>`).join('');
    }
    continue() {
        this.trigger('trial-modal->selectOffer', this.offer);
    }
}
TrialOffersController.targets = [
    'name',
    'price',
    'features'
];


;// CONCATENATED MODULE: ./components/trial/modal/success/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/trial/modal/success/index.js


class TrialSuccessController extends stimulus/* Controller */.Q {
    connect() {
        this.on('updateOffer', this.updateOffer.bind(this));
    }
    updateOffer(offer) {
        this.subscriptionTextTarget.textContent = offer.offerName;
        this.daysTextTarget.textContent = `${gon.flags.trial_settings.days} dias`;
        this.illustrationTarget.classList.add(`subscription-illustration--${offer.offerSubscription}`);
    }
}
TrialSuccessController.targets = [
    'subscriptionText',
    'daysText',
    'illustration'
];


;// CONCATENATED MODULE: ./components/trial/modal/index.js





class TrialModalController extends stimulus/* Controller */.Q {
    initialize() {
        const key = this.modalTarget.getAttribute('data-gateway-public-key');
        if (!key) {
            return;
        }
        vendorManager.ensure('mercadopago', ()=>{
            window.Mercadopago.setPublishableKey(key);
        }, 'https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js');
    }
    connect() {
        this.on('selectOffer', this.goToForm.bind(this));
        this.on('goToSuccess', this.goToSuccess.bind(this));
        this.eventData = {
            place: '',
            time: this.modalTarget.getAttribute('data-time'),
            page: this.getPageEventValue()
        };
        this.createEntryButtons();
        window.openTrialModal = (origin, offerId)=>this.openModal(origin, offerId);
    }
    getPageEventValue() {
        const url = window.location.href;
        if (url.includes('questoes/')) {
            return 'questoes show';
        }
        if (url.includes('questoes')) {
            return 'questoes';
        }
        return 'outras páginas';
    }
    openModal(origin, offerId) {
        this.eventData.place = origin;
        this.modalTarget.style.display = 'block';
        setTimeout(()=>{
            this.modalTarget.classList.add('q-trial-modal--open');
        }, 10);
        document.querySelector('body').classList.add('q-no-scroll');
        this.trackEvent('trial clicked');
        this.trigger('trial-offers->setInitialOffer', offerId);
    }
    closeModal() {
        this.modalTarget.classList.remove('q-trial-modal--open');
        setTimeout(()=>{
            this.modalTarget.style.display = 'none';
            this.goToOffers();
        }, 300);
        document.querySelector('body').classList.remove('q-no-scroll');
        const isSuccessScreenActive = this.screenSuccessTarget.classList.contains('q-trial-modal__screen--active');
        if (isSuccessScreenActive) {
            window.location.reload();
        }
    }
    hideCurrentScreen() {
        this.element.querySelector('.q-trial-modal__screen--active').classList.remove('q-trial-modal__screen--active');
    }
    trackEvent(name) {
        UserTracker.emit('event', {
            eventName: name,
            data: this.eventData
        });
    }
    goToOffers() {
        this.hideCurrentScreen();
        this.screenOffersTarget.classList.add('q-trial-modal__screen--active');
    }
    goToForm(offerData) {
        this.trigger('trial-form->updateOffer', offerData);
        this.trigger('trial-success->updateOffer', offerData);
        this.eventData['offer id'] = offerData.offerId;
        this.eventData['offer name'] = offerData.offerName;
        this.trackEvent('trial checkout started');
        this.hideCurrentScreen();
        this.screenFormTarget.classList.add('q-trial-modal__screen--active');
    }
    goToSuccess() {
        this.hideCurrentScreen();
        this.trackEvent('trial checkout completed');
        this.screenSuccessTarget.classList.add('q-trial-modal__screen--active');
    }
    createEntryButtons() {
        const { showButtonOnHeader, showFloatingButtonOnQuestionPage } = window.gon.flags.trial_settings;
        if (showButtonOnHeader) {
            const days = this.modalTarget.getAttribute('data-time');
            const $desktopHeader = document.querySelector('.q-desktop-right-nav');
            const $mobileMenu = document.querySelector('.q-segments-mobile-menu-cta');
            let $desktopButton = document.createElement('div');
            $desktopButton.innerHTML = `
            <button class="q-trial-navbar-button q-trial-navbar-button--desktop">
              Teste com ${days} dias gratuitos
            </button>
          `.trim();
            $desktopButton = $desktopButton.firstChild;
            let $mobileButton = document.createElement('div');
            $mobileButton.innerHTML = `
            <button class="q-trial-navbar-button q-trial-navbar-button--mobile">
              Teste ${days} dias grátis
            </button>
          `.trim();
            $mobileButton = $mobileButton.firstChild;
            $desktopHeader.insertBefore($desktopButton, $desktopHeader.firstChild);
            $mobileMenu.insertBefore($mobileButton, $mobileMenu.firstChild);
            $desktopButton.addEventListener('click', ()=>this.openModal('navbar button'));
            $mobileButton.addEventListener('click', ()=>this.openModal('navbar button'));
        }
        if (showFloatingButtonOnQuestionPage && window.location.href.includes('/questoes')) {
            let $floatingButton = document.createElement('div');
            $floatingButton.innerHTML = `
                <button class="q-trial-floating-button q-trial-floating-button--show">
                  <span class="text-mobile">Experimente grátis</span>
                  <span class="text-desktop">Experimente gratuitamente</span>
                  <i class="q-icon q-icon-times close-button"></i>
                </button>
              `.trim();
            $floatingButton = $floatingButton.firstChild;
            document.querySelector('body').appendChild($floatingButton);
            $floatingButton.addEventListener('click', (event)=>{
                if (event.target.classList.contains('close-button')) {
                    $floatingButton.remove();
                    return;
                }
                this.openModal('floating button');
            });
        }
    }
}
TrialModalController.targets = [
    'modal',
    'screenOffers',
    'screenForm',
    'screenSuccess'
];

if (!window.TrialApplication) {
    window.TrialApplication = stimulus/* Application.start */.M.start();
    window.TrialApplication.register('trial-modal', TrialModalController);
    window.TrialApplication.register('trial-offers', TrialOffersController);
    window.TrialApplication.register('trial-form', TrialFormController);
    window.TrialApplication.register('trial-success', TrialSuccessController);
}


/***/ }),

/***/ 87412:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./components/trial/top_bar/index.erb
var top_bar = __webpack_require__(49251);
// EXTERNAL MODULE: ./components/trial/top_bar/index.rb
var trial_top_bar = __webpack_require__(27320);
// EXTERNAL MODULE: ./components/trial/top_bar/components/activated/index.erb
var activated = __webpack_require__(4611);
// EXTERNAL MODULE: ./components/trial/top_bar/components/activated/index.rb
var components_activated = __webpack_require__(14308);
;// CONCATENATED MODULE: ./components/trial/top_bar/components/activated/index.js



// EXTERNAL MODULE: ./components/trial/top_bar/components/expired/index.erb
var expired = __webpack_require__(70792);
// EXTERNAL MODULE: ./components/trial/top_bar/components/expired/index.rb
var components_expired = __webpack_require__(9886);
;// CONCATENATED MODULE: ./components/trial/top_bar/components/expired/index.js



;// CONCATENATED MODULE: ./components/trial/top_bar/index.js




class TopBarTrial {
    toggleTopBar() {
        window.jQuery('.js-top-bar-trial-close', this.$context).on('click', ()=>{
            this.$context.hide();
            if (localStorage) {
                localStorage.setItem('closedTopBarTrial', true);
            }
        });
    }
    showTopBar() {
        if (!localStorage) {
            return;
        }
        const isClosedTopBarTrial = localStorage.getItem('closedTopBarTrial') === 'true';
        if (isClosedTopBarTrial) {
            this.$context.hide();
        } else {
            this.$context.show();
        }
    }
    constructor(){
        this.$context = window.jQuery('.js-top-bar-trial');
        this.showTopBar();
        this.toggleTopBar();
    }
}
(function() {
    new TopBarTrial();
})();


/***/ }),

/***/ 53301:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./fonts/qicons.eot
var qicons = __webpack_require__(31338);
// EXTERNAL MODULE: ./fonts/qicons.svg
var fonts_qicons = __webpack_require__(76862);
// EXTERNAL MODULE: ./fonts/qicons.ttf
var fonts_qicons_0 = __webpack_require__(57829);
// EXTERNAL MODULE: ./fonts/qicons.woff
var fonts_qicons_1 = __webpack_require__(52878);
// EXTERNAL MODULE: ./fonts/qicons.woff2
var qicons_woff2 = __webpack_require__(5896);
;// CONCATENATED MODULE: ./styles/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./styles/index.js








/***/ }),

/***/ 97970:
/***/ (() => {

window.initBlazy = function initBlazy1() {
    if ((self || window).blazyInstance) {
        (self || window).blazyInstance.revalidate();
    } else {
        (self || window).Blazy = Blazy;
        (self || window).blazyInstance = new Blazy({
            offset: 300
        });
    }
};
window.jQuery(document).on('shown.bs.collapse', ()=>initBlazy());
window.jQuery(document).on('shown.bs.tab', ()=>initBlazy());
window.jQuery(document).on('shown.bs.modal', ()=>initBlazy());
window.jQuery(document).on('turbolinks:render', ()=>{
    setTimeout(()=>initBlazy(), 100);
});
window.jQuery(document).ready(()=>initBlazy());
initBlazy();
setTimeout(()=>initBlazy(), 1500);


/***/ }),

/***/ 88526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CookieManager)
/* harmony export */ });
const MAXIMUM_EXPIRATION_YEARS = 1;
const DOMAINS = {
    development: 'development.odin',
    staging: 'qconcursos-hmg.com',
    production: 'qconcursos.com'
};
class CookieManager {
    static getCookie(name) {
        return this._getCookie(name);
    }
    static setPersistentCookie(name, value) {
        const expiration = new Date();
        expiration.setFullYear(expiration.getFullYear() + MAXIMUM_EXPIRATION_YEARS);
        this._setCookie(name, value, expiration);
    }
    static setSessionCookie(name, value) {
        this._setCookie(name, value);
    }
    static setExpirationCookie(name, value, days) {
        const expiration = new Date();
        expiration.setDate(expiration.getDate() + days);
        this._setCookie(name, value, expiration);
    }
    static removeCookie(name) {
        this._setCookie(name, null, new Date());
    }
    static _getCookie(name) {
        const prefix = name + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const array = decodedCookie.split(';');
        for(let i = 0; i < array.length; i++){
            let cookie = array[i];
            while(cookie.charAt(0) === ' '){
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(prefix) === 0) {
                return cookie.substring(prefix.length, cookie.length);
            }
        }
        return null;
    }
    static _setCookie(name, value, expiration = null) {
        const suffix = expiration ? ` expires=${expiration}` : '';
        document.cookie = `${name}=${value};domain=${DOMAINS[RAILS_ENV]};${suffix}`;
    }
}



/***/ }),

/***/ 4042:
/***/ (() => {

(function($) {
    const apply = function() {
        const $user = $('#js-current-user').get(0);
        window.currentUser = $user ? $user.dataset : false;
    };
    $(document).on('turbolinks:load', ()=>apply());
    apply();
})(window.jQuery);


/***/ }),

/***/ 5581:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var fontfaceobserver_fontfaceobserver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34127);
/* harmony import */ var fontfaceobserver_fontfaceobserver__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fontfaceobserver_fontfaceobserver__WEBPACK_IMPORTED_MODULE_0__);

const siteFont = new (fontfaceobserver_fontfaceobserver__WEBPACK_IMPORTED_MODULE_0___default())('Open Sans');
const iconsFont = new (fontfaceobserver_fontfaceobserver__WEBPACK_IMPORTED_MODULE_0___default())('qicons');
if (RAILS_ENV === 'development') {
    document.documentElement.classList.add('q-site-font-loaded');
    document.documentElement.classList.add('q-icon-font-loaded');
} else {
    siteFont.load().then(()=>{
        document.documentElement.classList.add('q-site-font-loaded');
    }).catch(()=>{
        document.documentElement.classList.add('q-site-font-loaded');
    });
    iconsFont.load().then(()=>{
        document.documentElement.classList.add('q-icon-font-loaded');
    }).catch(()=>{
        document.documentElement.classList.add('q-icon-font-loaded');
    });
}


/***/ }),

/***/ 92030:
/***/ (() => {

(function($) {
    'use strict';
    if (!$.fn.clearForm) {
        $.fn.clearForm = function(clearHidden = false) {
            const $form = $(this);
            if (!$form.is('form')) return $form;
            let $inputs = $form.find('input, select, textarea');
            if (!clearHidden) $inputs = $inputs.not('[type="hidden"]');
            // Cleaning Toggles
            $form.find('input[type="radio"]:checked, input[type="checkbox"]:checked').prop('checked', false).trigger('change');
            // Cleaning Inputs
            $inputs.not('input[type="radio"], input[type="checkbox"]').val('', true).trigger('change').focus();
            return $form;
        };
    }
})(window.jQuery);


/***/ }),

/***/ 4159:
/***/ (() => {

/**
 * Returns an array with error and results of a promise.
 * @param promise
 * @returns Promise([err, res])
 */ (self || window).withError = function(promise) {
    return promise.then((res)=>[
            null,
            res
        ]).catch((err)=>[
            err,
            null
        ]);
};
/**
 * Global error handler.
 * @param msg Message
 * @param exception Exception
 */ (self || window).handleError = function(msg, exception) {
    toastr.error(msg);
    Rollbar.error(msg, exception);
};


/***/ }),

/***/ 46655:
/***/ (() => {

window.jQuery.expr[':'].icontains = window.jQuery.expr.createPseudo(function(arg) {
    return function(elem) {
        return window.jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
});
window.jQuery.expr[':'].xcontains = function(a, i, m) {
    return window.jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};


/***/ }),

/***/ 51003:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./utils/lazy/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./utils/lazy/index.js

(function($) {
    'use strict';
    if (!$.fn.lazyReady) {
        $.fn.lazyReady = function() {
            const element = this;
            element.addClass('q-lazy-ready');
            element.removeClass('q-lazy');
            return element;
        };
    }
    // Fallback for lazyReady
    $(document).on('turbolinks:load', ()=>{
        const $lazy = $('.q-lazy');
        setTimeout(()=>{
            if (!$lazy.hasClass('q-lazy-ready')) {
                $lazy.addClass('q-lazy-ready');
                $lazy.removeClass('q-lazy');
            }
        }, 1500);
    });
})(window.jQuery);


/***/ }),

/***/ 90521:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ loadLazyScripts)
/* harmony export */ });
const loadLazyScripts = ()=>{
    const scripts = document.querySelectorAll('script[type="text/lazy-javascript"]');
    scripts.forEach((script)=>{
        const newScript = script.cloneNode(true);
        newScript.type = 'text/javascript';
        script.parentNode.replaceChild(newScript, script);
    });
};


/***/ }),

/***/ 93888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var components_modals_account_limit_free_modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49676);
/* harmony import */ var components_modals_account_not_confirm_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70637);
/* harmony import */ var components_modals_login_register_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66301);
/* harmony import */ var components_modals_question_belt_block_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42451);
/* harmony import */ var components_modals_session_expired_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82607);
/* harmony import */ var components_modals_account_limit_questions_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24363);
/* harmony import */ var utils_login_register__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32118);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87322);
/* harmony import */ var components_modals_not_subscribed_user_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11971);
/* harmony import */ var utils_countdown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56392);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}










const feedbacks = {
    utils: {
        block (event = new Event(null)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        },
        openModal (modal) {
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_7__/* ["default"].open */ .Z.open(`#${modal}`);
        },
        getEventResourceLimitSlug (resource) {
            const eventSlug = {
                question_comments: 'question commentaries',
                question_statistics: 'question statistics',
                question_teacher: 'commented_feedback'
            };
            return eventSlug[resource];
        }
    },
    buildLimitModal: function(dataKey) {
        const modalSeletor = 'js-account-limit-free-modal';
        const $modalBody = window.jQuery(`#${modalSeletor} .modal-content`);
        const data = $modalBody.data(dataKey);
        const imageFallback = $modalBody.data('imageFallback');
        $modalBody.find('a').attr('href', data.cta_link);
        window.jQuery(`#${modalSeletor} .js-benefits-list`).find('li p').each(function(index) {
            window.jQuery(this).html(data.args[index]);
        });
        if ($modalBody.find('[data-modal-image]')) {
            var _data_image;
            $modalBody.find('[data-modal-image]').attr('src', (_data_image = data == null ? void 0 : data.image) != null ? _data_image : imageFallback);
        }
        this.createCloseModalEventProxy(modalSeletor, dataKey);
        utils_modal_manager__WEBPACK_IMPORTED_MODULE_7__/* ["default"].populate */ .Z.populate(`#${modalSeletor}`, {
            username: currentUser.name,
            title: data.title,
            description: data.description,
            'btn-text': data.btn_text,
            'cta-text': data.cta_text
        });
        const $title = window.jQuery(`#${modalSeletor} [data-title]`);
        if ($title.length > 0) {
            $title.attr('aria-label', data.title);
        }
        this.utils.openModal(modalSeletor);
        (0,utils_countdown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            selector: `#${modalSeletor} .countdown`,
            template: '%H:%M:%S'
        });
    },
    buildBlockQuestionBeltModal () {
        (0,utils_countdown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            selector: '#js-question-belt-block-modal .limit-countdown',
            template: '%H:%M:%S'
        });
        this.createCloseModalEventProxy('js-question-belt-block-modal');
        this.utils.openModal('js-question-belt-block-modal');
    },
    createCloseModalEventProxy (modalSelector, key) {
        window.jQuery(`#${modalSelector}`).off('hidden.bs.modal').on('hidden.bs.modal', ()=>{
            const { showOnQuestionLimitation, showOnModalRestriction, active } = gon.flags.trial_settings;
            if (key === 'modal-questions-content' && active && showOnQuestionLimitation) {
                window.openTrialModal('question_limitation');
            }
            if (modalSelector === 'js-question-belt-block-modal' && active && (showOnQuestionLimitation || showOnModalRestriction)) {
                window.openTrialModal('question_limitation');
            }
            if (key === 'modal-restriction' && active && showOnModalRestriction) {
                window.openTrialModal('modal_restriction');
            }
        });
    },
    account (event, url = location.pathname, data) {
        utils_login_register__WEBPACK_IMPORTED_MODULE_6__/* ["default"].newLoginModal */ .Z.newLoginModal(url, data);
        this.utils.block(event);
    },
    confirmed_account (event) {
        this.utils.openModal('js-account-not-confirm-modal');
        this.utils.block(event);
    },
    createNotebookLimit (event) {
        this.buildLimitModal('modal-notebooks-content');
        this._sendAnalytics({
            'resource limited': 'notebooks'
        });
        this.utils.block(event);
    },
    practiceTestLimit (event) {
        this.buildLimitModal('modal-practice-tests-content');
        this._sendAnalytics({
            'resource limited': 'practice tests'
        });
        this.utils.block(event);
    },
    saveFilterLimit (event) {
        this.buildLimitModal('modal-stored-filters-content');
        this._sendAnalytics({
            'resource limited': 'stored filers'
        });
        this.utils.block(event);
    },
    resolveQuestionLimit (event) {
        this.buildLimitModal('modal-questions-content');
        this._sendAnalytics({
            'resource limited': 'questions'
        });
        this.utils.block(event);
    },
    viewCommentaryLimit (event) {
        this.buildLimitModal('modal-question-commentaries-content');
        this._sendAnalytics({
            'resource limited': 'question commentaries'
        });
        this.utils.block(event);
    },
    printQuestionsLimit (event) {
        this.buildLimitModal('modal-questions-print-content');
        this._sendAnalytics({
            'resource limited': 'question printing'
        });
        this.utils.block(event);
    },
    subscription (event) {
        var _event_detail;
        const allowedEvents = [
            'per_page',
            'sort',
            'commented_feedback'
        ];
        if (!allowedEvents.includes(event == null ? void 0 : (_event_detail = event.detail) == null ? void 0 : _event_detail.type)) {
            return;
        }
        new components_modals_not_subscribed_user_modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z('#js-not-subscribed-user-modal', event.detail.type);
        this.createCloseModalEventProxy('js-not-subscribed-user-modal', 'modal-restriction');
        this.utils.block(event);
    },
    trial (event) {
        var _event_detail;
        const allowedEvents = [
            'commented_feedback'
        ];
        if (!allowedEvents.includes(event == null ? void 0 : (_event_detail = event.detail) == null ? void 0 : _event_detail.type)) {
            return;
        }
        new components_modals_not_subscribed_user_modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z('#js-not-subscribed-user-modal', event.detail.type);
        this.utils.block(event);
    },
    newQuestionLimitModal (event) {
        this.utils.openModal('js-account-limit-questions-modal');
        this._sendAnalytics({
            'resource limited': 'questions'
        });
        const newQuestionLimitModal = new components_modals_account_limit_questions_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z();
        newQuestionLimitModal.load();
        this.utils.block(event);
    },
    questionBeltBlock () {
        this.buildBlockQuestionBeltModal();
        this._sendAnalytics({
            'resource limited': 'questions'
        });
        this.utils.block();
    },
    premium (event) {
        this.utils.openModal('js-not-premium-user-modal');
        this.utils.block(event);
    },
    premiumPlus (event) {
        this.utils.openModal('js-not-premium-plus-user-modal');
        this.utils.block(event);
    },
    black (event) {
        this.utils.openModal('js-not-black-user-modal');
        this.utils.block(event);
    },
    unlimited (event) {
        this.utils.openModal('js-not-unlimited-user-modal');
        this.utils.block(event);
    },
    digitalUnlimited (event) {
        this.utils.openModal('js-not-digital-unlimited-user-modal');
        this.utils.block(event);
    },
    questionBeltLimit (type) {
        this._sendAnalytics({
            'resource limited': this.utils.getEventResourceLimitSlug(type)
        });
        this.utils.block();
    },
    commented_feedback_enabled (event) {
        this.subscription(event);
        this._sendAnalytics({
            'resource limited': 'commented_feedback'
        });
    },
    _sendAnalytics (data = {}) {
        const $bodyEl = window.jQuery('body');
        let eventData = data;
        if ($bodyEl.hasClass('q-route-questions-show')) {
            eventData = _extends({}, eventData, {
                source_page: 'show'
            });
        }
        UserTracker.emit('event', {
            eventName: 'account limit reached',
            data: eventData
        });
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (feedbacks);


/***/ }),

/***/ 47459:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _feedbacks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93888);

(function() {
    'use strict';
    const limits = {
        start (context = document) {
            this.bindClicks(context);
        },
        bindClicks (context = document) {
            window.jQuery(context).off('click.user_limit', '[data-limit-reached]').on('click.user_limit', '[data-limit-reached]', (event)=>{
                const { limitReached, limitFeedback } = window.jQuery(event.currentTarget).data();
                if (limitReached === true) {
                    _feedbacks__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[limitFeedback](event);
                }
            });
        }
    };
    window.jQuery(document).on('turbolinks:load', ()=>{
        limits.start();
    });
    limits.start();
})();


/***/ }),

/***/ 27839:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./utils/permissions/feedbacks.js
var feedbacks = __webpack_require__(93888);
;// CONCATENATED MODULE: ./utils/permissions/rules.js
const rules = {
    utils: {
        bodyData () {
            return window.jQuery('body').data();
        }
    },
    account () {
        return this.utils.bodyData().isUserSignedIn;
    },
    confirmed_account () {
        return this.utils.bodyData().isUserEmailConfirmed;
    },
    trial () {
        return this.utils.bodyData().isUserFeatureTrial;
    },
    trialAndStandard () {
        return this.trial() && !this.subscription();
    },
    subscription () {
        return this.utils.bodyData().isUserSubscribed;
    },
    premium () {
        return this.utils.bodyData().isUserPremium || this.premiumPlus() || this.black() || this.unlimited() || this.digitalUnlimited() || this.judicial() || this.judicialUnlimited() || this.unlimitedQc(); // FIXME MAYKE PLEASE
    },
    premiumPlus () {
        return this.utils.bodyData().isUserPremiumPlus;
    },
    black () {
        return this.utils.bodyData().isUserBlack;
    },
    unlimited () {
        return this.utils.bodyData().isUserUnlimited;
    },
    digitalUnlimited () {
        return this.utils.bodyData().isUserDigitalUnlimited;
    },
    judicial () {
        return this.utils.bodyData().isUserJudicial;
    },
    judicialUnlimited () {
        return this.utils.bodyData().isUserJudicialUnlimited;
    },
    unlimitedQc () {
        return this.utils.bodyData().isUserUnlimitedQc;
    },
    commented_feedback_enabled () {
        return this.subscription() || gon.flags.question_belt_limits.commented_feedback_limit > 0;
    }
};
/* harmony default export */ const permissions_rules = (rules);

;// CONCATENATED MODULE: ./utils/permissions/permissions.js


(function() {
    'use strict';
    window.permissions = {
        // As permissões estão dispostas na ordem que elas devem ser testadas pelo script, devido a perfomance.
        // Dessa forma garante-se que o feedback seguirá a mesma sequência que o fluxo de criação de conta do usuário.
        _available: [
            'account',
            'confirmed_account',
            'trial',
            'trialAndStandard',
            'subscription',
            'premium',
            'black',
            'unlimited',
            'digital_unlimited',
            'judicial',
            'judicial_unlimited',
            'unlimited_qc',
            'commented_feedback_enabled'
        ],
        feedbacks: feedbacks/* default */.Z,
        start () {
            this.bindClicks();
        },
        prepare (permissions) {
            return permissions.sort((a, b)=>{
                return this._available.indexOf(a) - this._available.indexOf(b);
            });
        },
        hasPermissions (permissions, proceed = true, reason = null) {
            this.prepare(permissions).every((permission)=>{
                if (!permissions_rules[permission]) {
                    throw new Error(`The rule "${permission}" does not exists!`);
                }
                proceed = permissions_rules[permission]();
                reason = proceed ? null : permission;
                return proceed;
            });
            return {
                proceed,
                reason
            };
        },
        bindClicks (context = 'body') {
            window.jQuery('[data-permissions]', window.jQuery(context)).off('click.permissions').on('click.permissions', (event)=>{
                const data = window.jQuery(event.currentTarget).data();
                const permissions = data.permissions.split(',');
                const { proceed, reason } = this.hasPermissions(permissions);
                if (proceed && data.redirect) {
                    event.preventDefault;
                    Turbolinks.visit(data.redirect);
                    return;
                }
                if (!proceed) {
                    const url = data.redirect || `${location.pathname}${location.search}`;
                    this.feedbacks[reason](event, url, data);
                }
            });
        }
    };
    window.jQuery(document).on('turbolinks:load', ()=>{
        window.permissions.start();
    });
    window.permissions.start();
})();


/***/ }),

/***/ 15737:
/***/ (() => {

(function($) {
    'use strict';
    $(document).on('click', 'a[data-toggle="scroll-to"]', (e)=>{
        e.preventDefault();
        let $clickTarget = $(e.target);
        if (!$clickTarget.is('a')) {
            $clickTarget = $clickTarget.parents('a[data-toggle="scroll-to"]');
        }
        const id = $clickTarget.attr('href');
        const $target = $(id);
        if (!$target.length) {
            return;
        }
        $('html, body').stop().animate({
            scrollTop: $(id).offset().top
        }, 1000);
    });
})(window.jQuery);


/***/ }),

/***/ 92189:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./utils/statements/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./utils/statements/index.js



/***/ }),

/***/ 90048:
/***/ (() => {

/* eslint-disable no-prototype-builtins */ (function() {
    'use strict';
    if (!window.Storage) return;
    window._odinMemoryStorage = {};
    const originalSetItem = window.Storage.prototype.setItem;
    const originalGetItem = window.Storage.prototype.getItem;
    const originalRemoveItem = window.Storage.prototype.removeItem;
    window.Storage.prototype.setItem = function(key, value) {
        try {
            originalSetItem.bind(this)(key, value);
        } catch (ex) {
            window._odinMemoryStorage[key] = value;
        }
    };
    window.Storage.prototype.getItem = function(key) {
        if (window._odinMemoryStorage.hasOwnProperty(key)) return window._odinMemoryStorage[key];
        return originalGetItem.bind(this)(key);
    };
    window.Storage.prototype.removeItem = function(key) {
        if (window._odinMemoryStorage.hasOwnProperty(key)) {
            delete window._odinMemoryStorage[key];
            return;
        }
        originalRemoveItem.bind(this)(key);
    };
})();


/***/ }),

/***/ 16111:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var notyf_notyf_min_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69934);
/* harmony import */ var notyf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91457);


(function() {
    const options = {
        duration: 5000,
        dismissible: true,
        position: {
            x: 'right',
            y: 'top'
        },
        types: [
            {
                type: 'success',
                icon: false,
                background: '#23BE87'
            },
            {
                type: 'error',
                icon: false,
                background: '#F1173A'
            },
            {
                type: 'warning',
                background: '#F1B617',
                icon: false
            },
            {
                type: 'info',
                background: '#35ABFC',
                icon: false
            }
        ]
    };
    const init = ()=>{
        window.toastr = new notyf__WEBPACK_IMPORTED_MODULE_1__/* .Notyf */ .Iq(options);
        window.toastr.warning = (message)=>toastr.open({
                type: 'warning',
                message
            });
        window.toastr.info = (message)=>toastr.open({
                type: 'info',
                message
            });
    };
    document.addEventListener('turbolinks:load', ()=>{
        init();
    });
    init();
})();


/***/ }),

/***/ 33927:
/***/ (() => {

(function($) {
    'use strict';
    $(document).on('change', '.checkbox--button > input', function() {
        $(this).parent('.checkbox--button').toggleClass('checkbox--button-checked');
    });
    $(document).on('change', '.radio--button > input', function() {
        $(this).parent('.radio--button').toggleClass('radio--button-checked');
    });
})(window.jQuery);


/***/ }),

/***/ 59987:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55666);
/* harmony import */ var _scroll__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_scroll__WEBPACK_IMPORTED_MODULE_0__);

function handleJQueryEvents() {
    // Disabling old event listeners.
    window.odinListeners = [];
    document.addEventListener('turbolinks:before-visit', ()=>{
        window.odinListeners.forEach((listener)=>{
            let { el, args } = listener;
            window.jQuery(el).off(...args);
        });
        window.odinListeners = [];
    });
    // Proxying jQuery .on to store all event listeners of jQuery.
    const _on = window.jQuery.prototype.on;
    window.jQuery.prototype.on = function() {
        let el = this.get(0);
        if (el && el !== document && el !== window) {
            window.odinListeners.push({
                el,
                args: arguments
            });
        }
        return _on.call(this, ...arguments);
    };
}
(function() {
    'use strict';
    // Sending Is-Turbolinks-Request header in every Turbolinks calls.
    document.addEventListener('turbolinks:request-start', function(event) {
        window.isTurbolinksLoading = true;
        const xhr = event.data.xhr;
        xhr.setRequestHeader('Is-Turbolinks-Request', true);
    });
    document.addEventListener('turbolinks:load', function() {
        window.isTurbolinksLoading = false;
    });
    window.document.addEventListener('turbolinks:before-visit', (e)=>{
        const customUrls = [
            '/cursos',
            '/aulas-ao-vivo',
            '/playlist',
            '/video',
            '/simulados',
            '/'
        ];
        const current = e.data.url;
        const currentObject = new URL(current);
        // TODO: change 2 compare complex urls w/dynamic /:id and etc
        const urlPathName = '/' + currentObject.pathname.split('/')[1];
        const matchesUrls = customUrls.includes(urlPathName);
        if (matchesUrls) {
            e.preventDefault();
            window.location.assign(e.data.url);
        }
    });
    handleJQueryEvents();
    Turbolinks.start();
})();


/***/ }),

/***/ 55666:
/***/ (() => {

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
(function() {
    var _window_Turbolinks;
    if (!((_window_Turbolinks = window.Turbolinks) == null ? void 0 : _window_Turbolinks.controller)) {
        return;
    }
    const $document = window.jQuery(document);
    const initialScrollState = {
        top: null,
        anchor: null,
        animate: false
    };
    if (typeof Turbolinks.scrollState === 'undefined') {
        Turbolinks.scrollState = _extends({}, initialScrollState);
    }
    Turbolinks.resetScrollState = function() {
        Turbolinks.scrollState = _extends({}, initialScrollState);
    };
    Turbolinks.persistScroll = function(animate = false) {
        Turbolinks.scrollState.animate = animate;
        Turbolinks.scrollState.top = $document.scrollTop();
    };
    $document.on('turbolinks:click', (e)=>{
        if (typeof e.target.dataset.turbolinksScroll !== 'undefined') {
            Turbolinks.persistScroll();
        }
        if (typeof e.target.dataset.turbolinksAnimateScroll !== 'undefined') {
            Turbolinks.scrollState.animate = true;
        }
    }).on('turbolinks:render', ()=>{
        if (Turbolinks.scrollState.top) {
            window.scrollTo(0, Turbolinks.scrollState.top);
        }
        Turbolinks.resetScrollState();
    });
    // Intercepting Turbolinks scrollTo to enable scroll animation
    const _scrollToAnchor = Turbolinks.controller.scrollToAnchor;
    Turbolinks.controller.scrollToAnchor = function(id) {
        if (Turbolinks.scrollState.animate) {
            window.jQuery('html, body').animate({
                scrollTop: window.jQuery(`#${id}`).offset().top
            });
        } else {
            return _scrollToAnchor.call(Turbolinks.controller, ...arguments);
        }
    };
})();


/***/ }),

/***/ 72476:
/***/ (() => {

(function($) {
    'use strict';
    function greaterThan(a, b) {
        if (isNaN(parseInt(a))) return a > b;
        return parseInt(a) > parseInt(b);
    }
    function sortParams(params) {
        return $.param(params.sort((a, b)=>{
            if (a.name === b.name && a.value === b.value) return 0;
            if (a.name > b.name) return 1;
            if (a.name === b.name && greaterThan(a.value, b.value)) return 1;
            return -1;
        }));
    }
    function prepareQuery(params) {
        const filteredParams = params.filter((p)=>!!p.value);
        return sortParams(filteredParams);
    }
    $(document).on('submit', '[data-turbolinks-form="true"]', (e)=>{
        e.preventDefault();
        const $form = $(e.currentTarget);
        const query = prepareQuery($form.serializeArray());
        const url = $form.attr('action');
        if ($form.data('turbolinks-scroll')) Turbolinks.persistScroll();
        Turbolinks.visit(`${url}?${query}`);
    });
})(window.jQuery);


/***/ }),

/***/ 53546:
/***/ (() => {

(function($) {
    'use strict';
    class VendorManager {
        static _createScriptTag(name, url) {
            const script = document.createElement('script');
            script.id = `lazy-script-${name}`;
            script.type = 'text/javascript';
            script.src = url;
            script.async = true;
            return script;
        }
        static _createStyleTag(name, url) {
            const style = document.createElement('link');
            style.id = `lazy-style-${name}`;
            style.type = 'text/css';
            style.rel = 'stylesheet';
            style.href = url;
            return style;
        }
        static _createTags(name, scriptUrl, styleUrl = null) {
            const head = document.querySelector('head');
            const script = VendorManager._createScriptTag(name, scriptUrl);
            window.loadedVendors[name].script = script;
            if (styleUrl) {
                const style = VendorManager._createStyleTag(name, styleUrl);
                window.loadedVendors[name].style = style;
                VendorManager._handleLoadEvents(name, script, style);
                head.insertBefore(style, head.querySelector('link'));
            } else {
                script.onerror = (err)=>console.error(err);
                script.onload = ()=>VendorManager._execCallbacks(name);
            }
            head.appendChild(script);
        }
        static _execCallbacks(name) {
            const callbacks = window.loadedVendors[name].callbacks;
            $(callbacks).each((i, callback)=>{
                callback();
            });
            window.loadedVendors[name].isLoaded = true;
        }
        static _handleLoadEvents(name, script, style) {
            const scriptDeferred = $.Deferred();
            const styleDeferred = $.Deferred();
            script.onload = ()=>scriptDeferred.resolve();
            script.onerror = (err)=>console.error(err);
            style.onload = ()=>styleDeferred.resolve();
            style.onerror = (err)=>console.error(err);
            $.when(scriptDeferred, styleDeferred).done(()=>{
                VendorManager._execCallbacks(name);
            });
        }
        // TODO: Accept more than one vendor
        static ensure(name, ensureCallback, url = null) {
            const scriptUrl = url ? url : gon.vendor_paths[`vendors/${name}.js`];
            const styleUrl = gon.vendor_paths[`vendors/${name}.css`];
            const ensureCallbackWrapper = ()=>{
                $(document).trigger('vendor:loaded', name);
                ensureCallback();
            };
            window.loadedVendors = window.loadedVendors || {};
            const isTagsAlreadyAdded = document.querySelector(`#lazy-script-${name}`) || document.querySelector(`#lazy-style-${name}`);
            // Skip if already exists
            if (isTagsAlreadyAdded && window.loadedVendors[name] && !window.loadedVendors[name].isLoaded) {
                return window.loadedVendors[name].callbacks.push(ensureCallbackWrapper);
            } else if (window.loadedVendors[name] && window.loadedVendors[name].isLoaded) {
                return ensureCallbackWrapper();
            }
            if (!window.loadedVendors[name]) {
                window.loadedVendors[name] = {
                    isLoaded: false,
                    callbacks: []
                };
            }
            // FIXME - sometimes this function is called twice making the callback being pushed twice to the callbacks array above
            window.loadedVendors[name].callbacks.push(ensureCallbackWrapper);
            this._createTags(name, scriptUrl, styleUrl);
        }
    }
    window.vendorManager = VendorManager;
})(window.jQuery);


/***/ }),

/***/ 35496:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/questions-c7505b5a8b7867e6820b.png";

/***/ }),

/***/ 49304:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/statistics-85582dbd5555ce449177.png";

/***/ }),

/***/ 66382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/thinking-1250b2da95171aa9dfb3.svg";

/***/ }),

/***/ 66857:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/loading-8497189d43e20fe0f216.svg";

/***/ }),

/***/ 42888:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/banner-bb-fb6e83d9886c3ff47e2a.png";

/***/ }),

/***/ 80631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/banner-smart-c225f60d1874048565c9.jpg";

/***/ }),

/***/ 69394:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/appstore_icon-f15d5805632a4d06e589.png";

/***/ }),

/***/ 32818:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/play_icon-c6ed0072a5e57b897ea0.png";

/***/ }),

/***/ 33269:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/header-8f588080d4d52e8a4c3c.png";

/***/ }),

/***/ 13680:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/red_header-3330ca709a5449485c8a.png";

/***/ }),

/***/ 31338:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/qicons-7c66345fa86af63093ac.eot";

/***/ }),

/***/ 76862:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/qicons-e7f3e19d59cb8f67a927.svg";

/***/ }),

/***/ 57829:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/qicons-76c0518656fe5ba61a10.ttf";

/***/ }),

/***/ 52878:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/qicons-93809627bd9d377d27d0.woff";

/***/ }),

/***/ 5896:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/qicons-db204417718e549e6aca.woff2";

/***/ }),

/***/ 10089:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/halfpage-modal-360-e326a34ff557e11a157e.jpg";

/***/ }),

/***/ 87758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/halfpage-modal-400-209a7679e4b3f62f0ac9.jpg";

/***/ }),

/***/ 59406:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/work-home-dc55687379271c7c0ed1.svg";

/***/ }),

/***/ 76506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/hourglass-c371eb9ff2ea9e1d3ce9.svg";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "https://odin.qconcursos.com/packs/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			1034: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [8382,7879,7513,6759,5280,8670,3549,4693,1822,8055,8358,1064,1466,9868], () => (__webpack_require__(58055)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;